// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:37:56.270Z
// Property: Hunter's Ridge Apts. (ID: 6767906449165607)
// Collections: 26 amenities, 9 floorplans (live), 28 photos, 77 POIs, 3 reviews, 1 virtual tours, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165607",
  "property_external_id": "p8jyvcs",
  "property_zillow_url": "https://www.zillow.com/b/hunter%27s-ridge-oklahoma-city-ok-5Xnyd2/",
  "property_apartments_url": "https://www.apartments.com/hunters-ridge-apts-oklahoma-city-ok/p8jyvcs/",
  "property_google_business_url": "https://www.google.com/maps/place/Hunter's+Ridge/data=!4m2!3m1!1s0x0:0x306c8ce48395515?sa=X&ved=2ahUKEwj6ztnr-bySAxVIkmoFHSPNCT8Q_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "5913163789",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "hunter's-ridge-apts.",
  "property_name": "Hunter's Ridge Apts.",
  "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/hunters-ridge/",
  "property_domain": null,
  "property_address": "9211 North Council Road",
  "property_full_address": "9211 North Council Road, Oklahoma City, OK, 73132",
  "property_address_1": "9211 North Council Road",
  "property_address_2": null,
  "property_address_city": "Oklahoma City",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "73132",
  "property_address_country": "US",
  "property_address_county": "Oklahoma County",
  "property_neighborhood_address": "Northridge",
  "property_address_latitude": "35.5636",
  "property_address_longitude": "-97.6578",
  "property_email": "huntersridge@caseusa.com",
  "property_phone": "(405) 442-4347",
  "property_call_tracking_phone": "855-643-1619",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Hunter's Ridge Apts., where comfort meets convenience in the heart of Oklahoma City. Choose from spacious one- or two-bedroom floor plans, each adorned with modern amenities. Unwind by the pool, gather in the clubhouse, or enjoy our inviting picnic areas. Your new home awaits—schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Hunter's Ridge Apartments, your ideal living destination in the heart of Oklahoma City! Our vibrant community offers a selection of thoughtfully designed floor plans, including spacious one-bedroom and two-bedroom apartments, perfect for individuals and families alike. Each home is equipped with modern conveniences such as air conditioning, walk-in closets, and high-speed internet access to cater to your lifestyle needs.\n\nEnjoy an array of exceptional amenities designed to enhance your living experience. Take a refreshing dip in our sparkling pool, unwind at the sun deck, or host gatherings in the clubhouse and grilling area. For those who need to balance work and play, our business center and package service ensure that you stay connected and productive. Plus, with on-site maintenance and management, assistance is always just a call away!\n\nOur beautiful grounds feature a volleyball court, picnic area, and a serene courtyard – perfect for relaxing or meeting neighbors. Each apartment is designed with comfort in mind, featuring modern appliances including a dishwasher, refrigerator, microwave, and ample storage space. Choose from our various options, whether you prefer a sunroom, patio, or a cozy fireplace.\n\nAt Hunter's Ridge Apartments, we pride ourselves on offering a smoke-free environment with online services for hassle-free living. Conveniently located near shopping, dining, and entertainment, our community is the perfect place to call home.\n\nDon’t miss out on your chance to join our thriving community! Find your new home today – browse our availability or schedule a tour to visit Hunter's Ridge Apartments!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and a spa.",
    "public_id": "019cfb41-34a3-71ee-b967-565268701afb",
    "storage_key": "property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
    "width": 1240,
    "height": 826
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "212",
  "property_year_built": "1984",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.28301886792453",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Maximum 2 pets allowed, up to 100 lb each.",
  "property_pet_policy_description": "One‑Time Pet Fee: $500. Monthly Pet Rent: $30 per pet. Maximum 2 pets allowed, up to 100 lb each.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://huntersridgeapartmentsoklahomacity.securecafe.com/onlineleasing/hunters-ridge-apts/floorplans.aspx",
  "property_resident_portal_url": "https://huntersridgeapartmentsoklahomacity.securecafe.com/residentservices/hunters-ridge-apts/userlogin.aspx",
  "property_apply_now_url": "https://huntersridgeapartmentsoklahomacity.securecafe.com/onlineleasing/hunters-ridge-apts/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb40-cea2-7478-9b09-4cf1aecd01e5.webp",
  "property_primary_logo_media": {
    "alt_text": "Hunter's Ridge Apartments logo.",
    "public_id": "019cfb40-cea2-7478-9b09-4cf1aecd01e5",
    "storage_key": "property/6767906449165607/019cfb40-cea2-7478-9b09-4cf1aecd01e5.webp",
    "width": 320,
    "height": 150
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb42-352e-72dd-b96e-88d037182b4a.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb42-352e-72dd-b96e-88d037182b4a",
    "storage_key": "property/6767906449165607/019cfb42-352e-72dd-b96e-88d037182b4a.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb42-424a-754f-b7bb-94b4b0459dae.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Hunter's Ridge Apartments logo",
    "public_id": "019cfb42-424a-754f-b7bb-94b4b0459dae",
    "storage_key": "property/6767906449165607/019cfb42-424a-754f-b7bb-94b4b0459dae.webp",
    "width": 320,
    "height": 150
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb42-4aff-725d-8348-4149b7d871bf.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Hunter's Ridge Apartments logo",
    "public_id": "019cfb42-4aff-725d-8348-4149b7d871bf",
    "storage_key": "property/6767906449165607/019cfb42-4aff-725d-8348-4149b7d871bf.webp",
    "width": 320,
    "height": 150
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#3d3d3f",
  "property_secondary_color": "#aba093",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "525 - 1078",
  "property_sqft_min": "525",
  "property_sqft_max": "1078",
  "property_price_range": "794 - 1169",
  "property_price_min": "794",
  "property_price_max": "1169",
  "property_available_units": 10,
  "property_facebook_url": "https://www.facebook.com/HuntersRidgeOKC/",
  "property_instagram_url": "https://www.instagram.com/huntersridgeapartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJvzSWiWAEsocRFVU5SM7IBgM",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?cflt=apartments&find_loc=Oklahoma+City%2C+OK+73132",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Hunter's Ridge Apts.",
  "property_home_romance_title": "Embrace a Heartfelt Home, Where Joy Meets Comfort",
  "property_home_amenities_blurb": "At Hunter's Ridge Apts. in Oklahoma City, comfort meets convenience. Choose from our stylish one or two-bedroom floor plans, and enjoy exceptional amenities like a refreshing pool, spa, and vibrant clubhouse. Whether lounging on the sundeck or enjoying a picnic in the courtyard, your perfect home awaits!",
  "property_home_floorplans_blurb": "At Hunter's Ridge Apts. in vibrant Oklahoma City, your dream space awaits. With thoughtfully designed one and two-bedroom floor plans, you’ll find the ideal balance of comfort and style. Browse our available apartment homes today and uncover the perfect fit for your lifestyle at Hunter's Ridge!",
  "property_home_gallery_blurb": "At Hunter's Ridge Apts. in Oklahoma City, comfort meets convenience. Choose from spacious one or two-bedroom floor plans, and enjoy amenities like a sparkling pool, modern clubhouse, and serene courtyard with picnic areas. Picture yourself embracing a vibrant lifestyle where every detail, from air conditioning to high-speed internet, enhances your living experience.",
  "property_home_neighborhood_blurb": "Nestled in the heart of Oklahoma City, Hunter's Ridge Apts. offers more than just stylish one- and two-bedroom homes. Immerse yourself in a vibrant community surrounded by parks, educational institutions, and cultural attractions like the Oklahoma Museum of Flying and Martin Park Nature Center. Life here is just a heartbeat away from nature and adventure.",
  "property_home_reviews_blurb": "At Hunter's Ridge Apts. in Oklahoma City, residents rave about their spacious, beautifully designed one-bedroom apartments. With a seamless application process and attentive staff, you'll find comfort in every detail. \"10/10 price, staff, maintenance, grounds, pool,\" a happy tenant exclaims, proving that we prioritize your happiness. Join our community today!",
  "property_neighborhood_blurb": "At Hunter's Ridge Apts. in Oklahoma City, the vibrant surroundings offer more than just a home. Discover cultural gems like the Oklahoma Museum of Flying and the serene Martin Park Nature Center nearby. With universities, libraries, and parks just a stone's throw away, local treasures await amidst suburban tranquility.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Hunter's Ridge Apts. in Oklahoma City, indulge in a vibrant lifestyle enriched by thoughtful amenities. Dive into our sparkling pool, unwind at the clubhouse, or energize your spirit at the volleyball court. With cozy apartments featuring modern appliances and spacious layouts, comfort meets convenience in every corner.",
  "property_applynow_blurb": "At Hunter's Ridge Apts. in Oklahoma City, your ideal sanctuary awaits. Choose from spacious one or two-bedroom floor plans featuring a pool, clubhouse, and volleyball court. Enjoy modern comforts like walk-in closets and high-speed internet while connecting with neighbors in our inviting courtyard. Lease online today for your perfect home!",
  "property_contactus_blurb": "At Hunter's Ridge Apts. in vibrant Oklahoma City, we offer spacious one and two-bedroom floor plans designed for your comfort and lifestyle. Each layout balances style and functionality, creating an inviting sanctuary. Have questions? Contact our leasing team today to learn more about your future home!",
  "property_faqs_blurb": "At Hunter's Ridge Apts. in vibrant Oklahoma City, our spacious one and two-bedroom floor plans cater to your lifestyle. Have questions about our community? Our FAQs page provides insightful answers to help you settle into your ideal home. Your perfect living experience awaits—dive in and learn more today!",
  "property_floorplans_blurb": "At Hunter's Ridge Apts. in vibrant Oklahoma City, we offer thoughtfully designed one and two-bedroom floor plans tailored to your lifestyle. Our diverse layouts maximize comfort and style, ensuring your new home feels just right. Browse our available apartment homes today and envision your perfect space at Hunter's Ridge.",
  "property_gallery_blurb": "At Hunter's Ridge Apts. in Oklahoma City, every detail invites comfort and community. Imagine unwinding by the pool, gathering in the clubhouse, or enjoying a sunny afternoon in the picnic area. With spacious floor plans and top-notch amenities, picture yourself living the lifestyle you’ve always wanted—your new home awaits!",
  "property_interactivemap_blurb": "At Hunter's Ridge Apts. in Oklahoma City, your ideal living space awaits. Choose from spacious one- or two-bedroom floor plans, complete with modern amenities like a relaxing spa and invigorating volleyball court. Use our interactive community map to seamlessly find your perfect home, pricing, and more—all at your fingertips!",
  "property_pets_blurb": "At Hunter's Ridge Apts. in vibrant Oklahoma City, your furry friends are cherished just as much as you. With scenic green spaces and cozy corners, our community welcomes two pets up to 100 lbs each. Enjoy the perfect blend of comfort and companionship in your new home, all while enjoying our picturesque surroundings.",
  "property_referafriend_blurb": "At Hunter's Ridge Apts. in vibrant Oklahoma City, spacious one and two-bedroom floor plans await your personal touch. Surround yourself with great neighbors and remarkable amenities. Share the love—refer a friend to join our welcoming community today and elevate your living experience together!",
  "property_residentaccess_blurb": "At Hunter's Ridge Apts. in Oklahoma City, our thoughtfully designed one and two-bedroom floor plans elevate your living experience. Conveniently manage your home with our resident portal—pay rent, schedule maintenance, and more, all at your fingertips. Embrace a lifestyle of comfort and convenience in our vibrant community.",
  "property_reviews_blurb": "At Hunter's Ridge Apts. in Oklahoma City, residents rave about their experience, stating, \"10/10 price, staff, maintenance, and pool!\" With a swift application process and attentive team, you’ll find that comfort and community are at the heart of living here. Come see what our residents have to say!",
  "property_created_at": "1753982385126",
  "property_scheduletour_blurb": "Welcome to Hunter's Ridge Apts. in vibrant Oklahoma City, where comfort meets style in our thoughtfully designed one and two-bedroom floor plans. Ready to envision your future home? Schedule a tour and see what our residents love about their living experience in our welcoming community!",
  "property_thankyou_blurb": "Thank you for reaching out to Hunter's Ridge Apts. in vibrant Oklahoma City! With thoughtfully designed one and two-bedroom floor plans, your ideal living space awaits. Our team looks forward to connecting with you soon to help you find the perfect home that suits your lifestyle.",
  "property_virtualtours_blurb": "Step into your future at Hunter's Ridge Apts. in Oklahoma City, where spacious one and two-bedroom floor plans cater to your lifestyle. Experience the welcoming atmosphere and modern amenities firsthand—take a virtual tour today and envision your next home sweet home! Don't miss out on this exceptional community!",
  "property_copyright": "2025 All Rights Reserved. Hunter's Ridge Apts.",
  "property_seo_title_home": "Hunter's Ridge Apts. |  Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_home": "Embrace the comfort of Hunter's Ridge Apts. in OKC! Enjoy stunning amenities, spacious floor plans, and a vibrant community. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Oklahoma City, Oklahoma Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Hunter's Ridge Apts. in Oklahoma City! Choose from spacious one or two-bedroom layouts that fit your lifestyle. Browse now!",
  "property_seo_title_amenities": "Amenities | Oklahoma City, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Discover the charm of Hunter's Ridge Apts. in OKC! Enjoy amenities like a sparkling pool and cozy clubhouse—your ideal lifestyle awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_gallery": "Experience luxury at Hunter's Ridge Apts. in OKC—stunning views, top-notch amenities, and a vibrant community. Your dream home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Hunter's Ridge Apts. Apartments",
  "property_seo_description_virtualtours": "Experience Hunter's Ridge Apts. in Oklahoma City! Step into your future home with our immersive virtual tour of stunning one and two-bedroom apartments.",
  "property_seo_title_interactivemap": "Interactive Map | Hunter's Ridge Apts. Apartments",
  "property_seo_description_interactivemap": "Find your perfect Oklahoma City home at Hunter's Ridge Apts.! Use our interactive map to explore stunning floor plans, on-site amenities, and more.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_neighborhood": "Uncover the charm of Oklahoma City near Hunter's Ridge Apts. Dive into local favorites and explore vibrant spots that make this neighborhood a true gem!",
  "property_seo_title_contact": "Contact Us | Hunter's Ridge Apts.",
  "property_seo_description_contact": "Connect with Hunter's Ridge Apts. in Oklahoma City! Our friendly leasing team is ready to help you find your perfect one or two-bedroom home. Reach out now!",
  "property_seo_title_faqs": "FAQs | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_faqs": "Find quick answers to your questions about Hunter's Ridge Apts. in Oklahoma City. Learn about our amenities, floor plans, and community features today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_reviews": "Uncover the stories from our vibrant community at Hunter's Ridge Apts. in Oklahoma City! See why residents love life here, from amenities to warm connections.",
  "property_seo_title_applynow": "Apply Now | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_applynow": "Unwind at Hunter's Ridge Apts. in OKC! Choose from spacious one & two-bedroom layouts with premium amenities. Lease your new home online today!",
  "property_seo_title_residentaccess": "Resident Access | Hunter's Ridge Apts.",
  "property_seo_description_residentaccess": "Unlock convenience at Hunter's Ridge Apts in OKC! Log in to your resident portal for easy rent payment, maintenance requests, and community updates!",
  "property_seo_title_referafriend": "Refer A Friend | Hunter's Ridge Apts.",
  "property_seo_description_referafriend": "Great friends make great neighbors at Hunter's Ridge Apts! Refer a friend today and enjoy the perks of living in vibrant Oklahoma City together.",
  "property_seo_title_scheduletour": "Schedule a Tour | Hunter's Ridge Apts.",
  "property_seo_description_scheduletour": "Experience the charm of Hunter's Ridge Apts. in Oklahoma City! Schedule your tour today and envision your new home in our vibrant, welcoming community.",
  "property_seo_title_privacy": "Privacy Policy | Hunter's Ridge Apts.",
  "property_seo_description_privacy": "At Hunter's Ridge Apts. in Oklahoma City, your privacy is our priority. Learn how we protect your information. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Hunter's Ridge Apts.",
  "property_seo_description_accessibility": "Embrace inclusivity at Hunter's Ridge Apts. in OKC with our commitment to a welcoming digital experience for all.",
  "property_seo_title_sitemap": "Sitemap | Hunter's Ridge Apts.",
  "property_seo_description_sitemap": "Navigate Hunter's Ridge Apts. in Oklahoma City! Find everything you need about our community, amenities, and events with just a click. Visit our sitemap now!",
  "property_seo_title_thankyou": "Thank You | Hunter's Ridge Apts.",
  "property_seo_description_thankyou": "Thank you for reaching out to Hunter's Ridge Apts in OKC! Our team will be in touch soon to help you find your perfect home in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Oklahoma City, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865274650",
  "amenities": [
    {
      "id": "ec_e9ddf52b81f3fd5f6e5b80c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "yardi",
      "external_id": "127396638",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a198e5b80c8996a81cc3960a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "yardi",
      "external_id": "127396639",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8edad4f8654dc6070b779393",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "yardi",
      "external_id": "127396640",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_108975911b64590b26c7cb80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "yardi",
      "external_id": "127396641",
      "title": "Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e1e77571997194e6936efacd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "yardi",
      "external_id": "127396642",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4f29c9a79518e944c31265e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "yardi",
      "external_id": "127396643",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_140db63a162379494c8a6333",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "yardi",
      "external_id": "127396644",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_14073d232736b52f14534c6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "yardi",
      "external_id": "127396646",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_28326ef44f8502e877de78ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "yardi",
      "external_id": "128017283",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_19b014509d946397e40a5476",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "yardi",
      "external_id": "127396647",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_af7f61879f9d5ac2e013173b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "yardi",
      "external_id": "128042536",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e43854e9636ac57a51e178ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "yardi",
      "external_id": "127398119",
      "title": "Electronic Thermostat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_40ba89d81dd9188378d83364",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "yardi",
      "external_id": "127398120",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fb52f11262f81e9f5f732d51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "yardi",
      "external_id": "127398121",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c4a11798b6df94d80b85ef0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "yardi",
      "external_id": "127398122",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_85a9d2ea0d77dfd2f259cb16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "yardi",
      "external_id": "127398123",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1d59383a8856c19d75360afc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "yardi",
      "external_id": "127398124",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a9478b3884826b501bb7c3c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "yardi",
      "external_id": "127398125",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_acc181513a6a2850232f079a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "yardi",
      "external_id": "127398126",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1733692d49798f1390ff212c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "yardi",
      "external_id": "127398127",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_250802b7dd782a49b2ce2672",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "yardi",
      "external_id": "127398128",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e5797702348ae766cb46fe35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "yardi",
      "external_id": "127398129",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_080b307cb679f0c5c4369a77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "yardi",
      "external_id": "127398130",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9199f95210f47f58601af757",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "yardi",
      "external_id": "127398131",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_288366e6c4c01ca22d3cea32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "yardi",
      "external_id": "127398132",
      "title": "W/D Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_21ff224d250a9526e363d043",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "yardi",
      "external_id": "127398133",
      "title": "Wheelchair Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_00721aa3-b2ef-497e-b8d9-ca1c48147e25",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-cce2-754e-a220-9d37af436a10.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a table with an umbrella.",
        "public_id": "019db6dd-cce2-754e-a220-9d37af436a10",
        "storage_key": "property/6767906449165607/019db6dd-cce2-754e-a220-9d37af436a10.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and a shaded seating area.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a table with an umbrella.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9f6a32fb-8347-4818-b8e2-687eaa56c272",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-cb68-751b-bcf0-87a9dd6624fd.webp",
      "image_media": {
        "alt_text": "Resort-style outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "019db6dd-cb68-751b-bcf0-87a9dd6624fd",
        "storage_key": "property/6767906449165607/019db6dd-cb68-751b-bcf0-87a9dd6624fd.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling resort-style swimming pool, surrounded by lush landscaping and comfortable lounge chairs. Perfect for soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6f47ef5b-c921-4202-a6d5-ab897d479bcc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-c240-752d-bfbc-f767eed7c63c.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and outdoor seating area.",
        "public_id": "019db6dd-c240-752d-bfbc-f767eed7c63c",
        "storage_key": "property/6767906449165607/019db6dd-c240-752d-bfbc-f767eed7c63c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable lounge seating. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and outdoor seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5932f26e-56d4-4f9f-ba70-c9850ec8573b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-bc53-70a1-8ff2-34453cc42ad1.webp",
      "image_media": {
        "alt_text": "Hunter's Ridge apartment building exterior with a red cube sign in front.",
        "public_id": "019db6dd-bc53-70a1-8ff2-34453cc42ad1",
        "storage_key": "property/6767906449165607/019db6dd-bc53-70a1-8ff2-34453cc42ad1.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome home to Hunter's Ridge apartments, featuring a beautifully maintained exterior and lush green spaces.",
      "link": "",
      "alt_text": "Hunter's Ridge apartment building exterior with a red cube sign in front.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_65bbde22-a862-4f9a-8b67-87b44fac03d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-b25c-70d8-a8eb-71e70feaa24c.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with balconies and a walkway.",
        "public_id": "019db6dd-b25c-70d8-a8eb-71e70feaa24c",
        "storage_key": "property/6767906449165607/019db6dd-b25c-70d8-a8eb-71e70feaa24c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "View of the apartment building exteriors, showcasing private balconies and well-maintained grounds.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with balconies and a walkway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c60a59ba-e655-4042-b206-49c549ae103a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-b999-7069-aaeb-617efbe5b0dd.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured lawns and trees.",
        "public_id": "019db6dd-b999-7069-aaeb-617efbe5b0dd",
        "storage_key": "property/6767906449165607/019db6dd-b999-7069-aaeb-617efbe5b0dd.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Discover comfortable living in our apartment community, featuring beautifully maintained grounds and exterior views.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with manicured lawns and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b49bf915-3510-40e4-8fc1-b98eba14a6a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-b05a-739c-8029-342c098f75aa.webp",
      "image_media": {
        "alt_text": "Laundry room with multiple washers and dryers.",
        "public_id": "019db6dd-b05a-739c-8029-342c098f75aa",
        "storage_key": "property/6767906449165607/019db6dd-b05a-739c-8029-342c098f75aa.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "On-site laundry facilities with convenient access to washers and dryers, making chores a breeze.",
      "link": "",
      "alt_text": "Laundry room with multiple washers and dryers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6b0b7c4b-daea-4af3-b040-03b39c9b1175",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-abee-7058-8a78-e40c647afca0.webp",
      "image_media": {
        "alt_text": "Laundry room with multiple washers and dryers.",
        "public_id": "019db6dd-abee-7058-8a78-e40c647afca0",
        "storage_key": "property/6767906449165607/019db6dd-abee-7058-8a78-e40c647afca0.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities equipped with modern washers and dryers, making chores easy.",
      "link": "",
      "alt_text": "Laundry room with multiple washers and dryers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7f49b4b7-1f96-43fb-92e7-17d32fecbe00",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-834a-75b2-8791-e4d3fb653e0d.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and spa area with lounge chairs and apartment buildings in the background.",
        "public_id": "019db6dd-834a-75b2-8791-e4d3fb653e0d",
        "storage_key": "property/6767906449165607/019db6dd-834a-75b2-8791-e4d3fb653e0d.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool or relax in the spa. Lounge chairs are available for sunbathing and relaxation.",
      "link": "",
      "alt_text": "Resort-style swimming pool and spa area with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5f4ae55d-23d0-488f-8e78-01f95c4cb73c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-8293-7440-8bdc-1234688cf160.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a picnic table near an apartment building.",
        "public_id": "019db6dd-8293-7440-8bdc-1234688cf160",
        "storage_key": "property/6767906449165607/019db6dd-8293-7440-8bdc-1234688cf160.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, perfect for relaxing on a warm day. Amenities include comfortable lounge chairs and a shaded picnic area.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a picnic table near an apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_81abbe46-b861-4960-abb4-14c7df673419",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-83ca-7789-be7f-5fe372c58148.webp",
      "image_media": {
        "alt_text": "Covered parking spots in front of apartment buildings.",
        "public_id": "019db6dd-83ca-7789-be7f-5fe372c58148",
        "storage_key": "property/6767906449165607/019db6dd-83ca-7789-be7f-5fe372c58148.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Covered parking available for residents. Easy access to your apartment.",
      "link": "",
      "alt_text": "Covered parking spots in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_03c3718b-fa1e-4208-839a-311673fbe52f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-313c-77a9-815b-3af2e498d735.webp",
      "image_media": {
        "alt_text": "Balcony view of community grounds with large tree and apartment buildings in the background.",
        "public_id": "019db6dd-313c-77a9-815b-3af2e498d735",
        "storage_key": "property/6767906449165607/019db6dd-313c-77a9-815b-3af2e498d735.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy your morning coffee on your private balcony overlooking the community grounds, featuring mature trees and charming apartment buildings.",
      "link": "",
      "alt_text": "Balcony view of community grounds with large tree and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d9510410-fbf0-42bf-b87d-ba3321381f59",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-302f-764b-855a-b092cd27b793.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with shelves and hanging rods.",
        "public_id": "019db6dd-302f-764b-855a-b092cd27b793",
        "storage_key": "property/6767906449165607/019db6dd-302f-764b-855a-b092cd27b793.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and hanging space for all your storage needs.",
      "link": "",
      "alt_text": "Empty walk-in closet with shelves and hanging rods.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_58aab3f3-98ca-4262-9635-824ad33c7290",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-3126-7098-8d03-f7d00b76006b.webp",
      "image_media": {
        "alt_text": "Bathroom with wood-look flooring, white tiled tub and shower surround, and wooden vanity cabinets.",
        "public_id": "019db6dd-3126-7098-8d03-f7d00b76006b",
        "storage_key": "property/6767906449165607/019db6dd-3126-7098-8d03-f7d00b76006b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A bright bathroom featuring a white tub and shower, a vanity with a sink and wooden cabinets, and a large mirror.",
      "link": "",
      "alt_text": "Bathroom with wood-look flooring, white tiled tub and shower surround, and wooden vanity cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a700948f-1a27-4c1e-b3c4-aded8ecc0a09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-1dc8-7235-bcaf-1d346ca58a80.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, stainless steel sink, white dishwasher, and white oven.",
        "public_id": "019db6dd-1dc8-7235-bcaf-1d346ca58a80",
        "storage_key": "property/6767906449165607/019db6dd-1dc8-7235-bcaf-1d346ca58a80.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A cozy kitchen featuring rich wooden cabinets, a dual-basin sink, a dishwasher, and a white oven with a microwave above. Perfect for meal preparation and gathering.",
      "link": "",
      "alt_text": "Kitchen with wooden cabinets, stainless steel sink, white dishwasher, and white oven.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_84e44ce3-e9f9-47e9-846b-c9382c49435e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-20eb-717d-a5cd-5e8bb5353308.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, pillows, and curtains.",
        "public_id": "019db6dd-20eb-717d-a5cd-5e8bb5353308",
        "storage_key": "property/6767906449165607/019db6dd-20eb-717d-a5cd-5e8bb5353308.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable bed, decorative pillows, and stylish curtains. Offers ample closet space and easy access to the bathroom.",
      "link": "",
      "alt_text": "Bedroom with a bed, pillows, and curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ad394b5e-ad37-4081-8cd8-07be9c0dcd40",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-1fa6-741f-9c48-48ff42b69a44.webp",
      "image_media": {
        "alt_text": "Bedroom with a wooden bed frame, nightstand, and window.",
        "public_id": "019db6dd-1fa6-741f-9c48-48ff42b69a44",
        "storage_key": "property/6767906449165607/019db6dd-1fa6-741f-9c48-48ff42b69a44.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen-size bed with plush pillows and a textured throw blanket. A wooden nightstand with a lamp and decorative art complete the space.",
      "link": "",
      "alt_text": "Bedroom with a wooden bed frame, nightstand, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2cf1ab78-7b52-4a9e-b715-9a395de40368",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-1cfd-7769-8865-c87564c5e8ac.webp",
      "image_media": {
        "alt_text": "Dining area with high table and chairs and view of balcony and apartment buildings.",
        "public_id": "019db6dd-1cfd-7769-8865-c87564c5e8ac",
        "storage_key": "property/6767906449165607/019db6dd-1cfd-7769-8865-c87564c5e8ac.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy your meals at the high-top dining table, perfect for intimate dinners or morning coffee, with a view of your private balcony and the surrounding community.",
      "link": "",
      "alt_text": "Dining area with high table and chairs and view of balcony and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5a190ca1-b5b3-470c-9a4e-cec44f4e9895",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-1d9b-738b-b1ce-df4112f7e761.webp",
      "image_media": {
        "alt_text": "Living room with dining area and kitchen view.",
        "public_id": "019db6dd-1d9b-738b-b1ce-df4112f7e761",
        "storage_key": "property/6767906449165607/019db6dd-1d9b-738b-b1ce-df4112f7e761.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living area with a modern dining nook and a glimpse into the fully-equipped kitchen. Perfect for entertaining or everyday living.",
      "link": "",
      "alt_text": "Living room with dining area and kitchen view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_504bbf37-00ce-4017-b85c-6cce05842884",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-1fe4-7158-9ba4-35fdcfbaeab3.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed, dresser, and mirror.",
        "public_id": "019db6dd-1fe4-7158-9ba4-35fdcfbaeab3",
        "storage_key": "property/6767906449165607/019db6dd-1fe4-7158-9ba4-35fdcfbaeab3.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-sized bed with decorative pillows, a large dresser with a mirror, and neutral carpeting.",
      "link": "",
      "alt_text": "Bedroom with a king-sized bed, dresser, and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9afff421-5241-4bfa-b17b-413de445db7e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-1dbf-757b-81be-45538f839216.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, sink, and dishwasher.",
        "public_id": "019db6dd-1dbf-757b-81be-45538f839216",
        "storage_key": "property/6767906449165607/019db6dd-1dbf-757b-81be-45538f839216.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Charming kitchen featuring warm wood cabinets, a double basin sink, and a dishwasher. The space includes decorative elements and a glimpse into the adjacent living area.",
      "link": "",
      "alt_text": "Kitchen with wood cabinets, sink, and dishwasher.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1b2a227b-48bf-4739-994a-5b0233379cb3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-1cb5-76fa-96ea-d57b84652448.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, wooden cabinets, and hardwood floors.",
        "public_id": "019db6dd-1cb5-76fa-96ea-d57b84652448",
        "storage_key": "property/6767906449165607/019db6dd-1cb5-76fa-96ea-d57b84652448.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Modern and functional kitchen featuring white appliances, ample wooden cabinet storage, and beautiful hardwood flooring. Perfect for everyday cooking and entertaining.",
      "link": "",
      "alt_text": "Kitchen with white appliances, wooden cabinets, and hardwood floors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2781fe5d-992a-4f83-aa0b-5793079a0e2f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-061c-713a-b4f0-80e80a2c0d4e.webp",
      "image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and dining area visible through an opening.",
        "public_id": "019db6dd-061c-713a-b4f0-80e80a2c0d4e",
        "storage_key": "property/6767906449165607/019db6dd-061c-713a-b4f0-80e80a2c0d4e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living area with comfortable seating and a dedicated dining space, perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with sectional sofa, coffee table, and dining area visible through an opening.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b780475b-1c0e-4204-9199-6ed5ea300e99",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-1afd-7158-9db6-9e6b6ad3478f.webp",
      "image_media": {
        "alt_text": "A sectional sofa in a living room with a coffee table and accent decor.",
        "public_id": "019db6dd-1afd-7158-9db6-9e6b6ad3478f",
        "storage_key": "property/6767906449165607/019db6dd-1afd-7158-9db6-9e6b6ad3478f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A modern and stylish living room featuring a comfortable sectional sofa, a unique coffee table, and elegant decorative accents.",
      "link": "",
      "alt_text": "A sectional sofa in a living room with a coffee table and accent decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_12cab039-6ea5-4195-abb4-bdcd858f9a80",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-065e-72b5-84cd-3463a1a77791.webp",
      "image_media": {
        "alt_text": "Leasing center entrance with brick and siding exterior and landscaping.",
        "public_id": "019db6dd-065e-72b5-84cd-3463a1a77791",
        "storage_key": "property/6767906449165607/019db6dd-065e-72b5-84cd-3463a1a77791.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to our leasing center, your first stop to discover our vibrant community. Exterior view.",
      "link": "",
      "alt_text": "Leasing center entrance with brick and siding exterior and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0d77622c-a2ab-481c-b306-2c0e6e413c59",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-0650-755f-9b02-2fe76c87bbd6.webp",
      "image_media": {
        "alt_text": "Kitchenette with turquoise cabinets, stainless steel appliances, and brick accent wall.",
        "public_id": "019db6dd-0650-755f-9b02-2fe76c87bbd6",
        "storage_key": "property/6767906449165607/019db6dd-0650-755f-9b02-2fe76c87bbd6.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Enjoy a convenient kitchenette featuring turquoise cabinets, stainless steel appliances including a refrigerator, microwave, and toaster, perfect for preparing quick meals or snacks.",
      "link": "",
      "alt_text": "Kitchenette with turquoise cabinets, stainless steel appliances, and brick accent wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5ce80ed9-6f17-4612-b3ce-28e05d34d6b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-0195-770b-a5db-f2385f375ec3.webp",
      "image_media": {
        "alt_text": "Lobby lounge area with comfortable seating, coffee table, and decorative elements.",
        "public_id": "019db6dd-0195-770b-a5db-f2385f375ec3",
        "storage_key": "property/6767906449165607/019db6dd-0195-770b-a5db-f2385f375ec3.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed lobby lounge, featuring plush seating and a stylish coffee table perfect for gathering.",
      "link": "",
      "alt_text": "Lobby lounge area with comfortable seating, coffee table, and decorative elements.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b26495bc-2c04-466b-b29a-42e69e3ded76",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dc-fed8-73e8-bfd4-e3420ea077be.webp",
      "image_media": {
        "alt_text": "Hunter's Ridge Apartments monument sign with brick base.",
        "public_id": "019db6dc-fed8-73e8-bfd4-e3420ea077be",
        "storage_key": "property/6767906449165607/019db6dc-fed8-73e8-bfd4-e3420ea077be.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to Hunter's Ridge Apartments, featuring a prominent monument sign at the property entrance.",
      "link": "",
      "alt_text": "Hunter's Ridge Apartments monument sign with brick base.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_a2479818-395f-423c-882b-9fcc808a1675",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Clark Crew BBQ",
      "poi_type": "Restaurants",
      "poi_address": "3510 Northwest Expy, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Casual establishment with a patio for pit-smoked beef brisket, ribs, pulled pork and more.",
      "poi_long_description": "Diners say this barbecue restaurant serves up delicious burnt ends, brisket, ribs, and sausage, with sides of mac and cheese, baked beans, and cornbread. They also highlight the friendly and attentive service, and the lively back patio with live music.\n\nSome reviews mention the parking can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-3de0-731c-9153-96b3f9ef7691.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3de0-731c-9153-96b3f9ef7691",
        "storage_key": "property/6767906449165607/019d2709-3de0-731c-9153-96b3f9ef7691.webp",
        "width": 599,
        "height": 596
      },
      "poi_business_url": "http://www.clarkcrewbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3587788996052338906&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "clark-crew-bbq",
      "poi_latitude": "35.5323986",
      "poi_longitude": "-97.5816496",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-724-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-75bf-759e-be92-8831903ac90b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-75bf-759e-be92-8831903ac90b",
        "storage_key": "property/6767906449165607/019d2709-75bf-759e-be92-8831903ac90b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6r6_-4asocR2kjBPhVjyjE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_f202b1a9-823d-4a2e-bb9f-566082aa2b09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Louie's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "9401 Lake Hefner Pkwy, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Casual eatery offering burgers and other American eats at a location overlooking Lake Hefner.",
      "poi_long_description": "People say this bar and grill offers delicious burgers, fish tacos, and wraps, and they highlight the sweet potato fries and cherry cocktail. They also like the beautiful lake views, especially at sunset, the live music, and the outdoor patio.\n\nOther reviews mention the noise level can be distracting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-3e57-7184-bfb7-ac13413dee95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3e57-7184-bfb7-ac13413dee95",
        "storage_key": "property/6767906449165607/019d2709-3e57-7184-bfb7-ac13413dee95.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://louiesgrillandbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13485773733165357309&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "louies-grill--bar",
      "poi_latitude": "35.5657821",
      "poi_longitude": "-97.5775183",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-751-2298",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-75b7-72a8-9b12-3e5a37dd8513.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-75b7-72a8-9b12-3e5a37dd8513",
        "storage_key": "property/6767906449165607/019d2709-75b7-72a8-9b12-3e5a37dd8513.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlSzs7gwbsocR_ViddsIXJ7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_438a3681-bb8e-465e-8803-4846a3910c25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Meddys",
      "poi_type": "Restaurants",
      "poi_address": "9404 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this Mediterranean restaurant serves delicious dishes like the Meddys Main Plate, hummus bowl, and garlic chicken, with generous portions and fresh, flavorful ingredients. They highlight the reasonable prices, casual and modern atmosphere, and the availability of outdoor seating and live music. They also like the friendly and attentive staff, and the quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-3f33-75d9-89f3-140098fb99dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3f33-75d9-89f3-140098fb99dc",
        "storage_key": "property/6767906449165607/019d2709-3f33-75d9-89f3-140098fb99dc.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.meddys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10733599644329479405&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "meddys",
      "poi_latitude": "35.56632889999999",
      "poi_longitude": "-97.5666625",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-546-1003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-75bf-759e-be92-8831903ac90b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-75bf-759e-be92-8831903ac90b",
        "storage_key": "property/6767906449165607/019d2709-75bf-759e-be92-8831903ac90b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIS_1pD8bsocR7YyE6QFo9ZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_91e9ed4a-579e-4ae2-b50c-ba167d5decb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Oklahoma City Incredible Pizza Company",
      "poi_type": "Restaurants",
      "poi_address": "5833 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Buffet dining as well as an arcade, laser tag arena and go-karts for kids' parties and other fun days out.",
      "poi_long_description": "Visitors say this pizza restaurant offers a buffet with a variety of food, including pizza, hot dogs, tacos, chicken, and a salad bar, as well as fun attractions like go-karts and laser tag. They like the friendly and helpful staff, the clean facilities, and the great value for families, with many mentioning it's a popular spot for birthday parties.\n\nSome reviews mention the buffet can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-3ea2-7119-a235-f6fc82ef7e5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3ea2-7119-a235-f6fc82ef7e5c",
        "storage_key": "property/6767906449165607/019d2709-3ea2-7119-a235-f6fc82ef7e5c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://incrediblepizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7640346941500558065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-city-incredible-pizza-company",
      "poi_latitude": "35.5504818",
      "poi_longitude": "-97.6162357",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-728-8360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-75bf-759e-be92-8831903ac90b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-75bf-759e-be92-8831903ac90b",
        "storage_key": "property/6767906449165607/019d2709-75bf-759e-be92-8831903ac90b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ30Sq7dMEsocR8QriIBD3B2o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_072de7bf-935a-4b3b-97e0-f8d3feaa9f54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Mariscos El General - Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "4559 NW 23rd St, Oklahoma City, OK 73127, USA",
      "poi_short_description": "Live music and lively restaurant featuring seafood dishes, along with a full bar of cocktails, beer, and wine.",
      "poi_long_description": "People say this seafood restaurant serves delicious aguachiles, ceviche, and octopus. They highlight the generous portions, fresh ingredients, and flavorful dishes. They also like the attentive and friendly staff, and the lively atmosphere with live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-4302-704a-a4f8-a406dfedff89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4302-704a-a4f8-a406dfedff89",
        "storage_key": "property/6767906449165607/019d2709-4302-704a-a4f8-a406dfedff89.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://mariscoselgeneraloklahomacity.shop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9041095668201211933&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mariscos-el-general---oklahoma-city",
      "poi_latitude": "35.4947375",
      "poi_longitude": "-97.6033184",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-283-2430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-75bf-759e-be92-8831903ac90b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-75bf-759e-be92-8831903ac90b",
        "storage_key": "property/6767906449165607/019d2709-75bf-759e-be92-8831903ac90b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyUIWCmMRsocRHch0w5tseH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_37b4fc70-c292-4706-9c74-db6dbbbfcbcb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Feria Latina Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "4909 NW 23rd St, Oklahoma City, OK 73127, USA",
      "poi_short_description": "Latino grocery and food store featuring fresh produce and a bakery.",
      "poi_long_description": "People say this supermarket offers fresh produce and delicious bakery items. They also highlight the reasonable prices on marinated meats and the convenient on-site restaurant.\n\nOther reviews mention the parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-436e-73f9-b326-85b6f40d5b16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-436e-73f9-b326-85b6f40d5b16",
        "storage_key": "property/6767906449165607/019d2709-436e-73f9-b326-85b6f40d5b16.webp",
        "width": 949,
        "height": 1265
      },
      "poi_business_url": "http://www.laferialatina.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7639629429527723566&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "feria-latina-supermarket",
      "poi_latitude": "35.4938889",
      "poi_longitude": "-97.6113889",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-606-4004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-752a-70ce-b178-f1c01572d985.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-752a-70ce-b178-f1c01572d985",
        "storage_key": "property/6767906449165607/019d2709-752a-70ce-b178-f1c01572d985.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm6vpcQIQsocRLr6eWn1qBWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_f220d2fd-dc52-4b56-a01b-c04eee3ddfc2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "3535 NW 39th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Fresh meat and produce alongside bulk bins, plus a deli counter.",
      "poi_long_description": "Shoppers say this grocery store offers a wide variety of bulk items, including coffee beans, spices, and baking supplies, as well as fresh produce, delicious sushi, and a great deli selection. They also highlight the low prices, friendly staff, and clean store.\n\nSome reviews mention the checkout lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-439f-75d2-ab54-8831868f19ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-439f-75d2-ab54-8831868f19ea",
        "storage_key": "property/6767906449165607/019d2709-439f-75d2-ab54-8831868f19ea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=888982261208729925&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "35.512444",
      "poi_longitude": "-97.5798107",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-832-5070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-752a-70ce-b178-f1c01572d985.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-752a-70ce-b178-f1c01572d985",
        "storage_key": "property/6767906449165607/019d2709-752a-70ce-b178-f1c01572d985.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCahmuZoasocRRUn4EqhMVgw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_25b2644b-f91f-485e-a7a4-f3fea8d39a44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "3040 NW 59th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Large hardware chain stocked with a wide selection of tools, lumber and building materials, plus appliances.",
      "poi_long_description": "People say this home improvement store usually has what they need. They also highlight the staff is friendly and helpful.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-43bc-733b-9eb9-70f506e2d037.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-43bc-733b-9eb9-70f506e2d037",
        "storage_key": "property/6767906449165607/019d2709-43bc-733b-9eb9-70f506e2d037.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/N-Oklahoma-City/OK/Oklahoma-City/73112/3902?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8923094349114202389&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "35.5313564",
      "poi_longitude": "-97.5691642",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-843-5008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-758b-725c-97fa-189f44fd803e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-758b-725c-97fa-189f44fd803e",
        "storage_key": "property/6767906449165607/019d2709-758b-725c-97fa-189f44fd803e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJGSHGIfYasocRFVk_sAgz1Xs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_07de43ac-1ad0-4a54-a641-9e77ddf81b31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Barnes & Noble",
      "poi_type": "Shopping & Retail",
      "poi_address": "6100 N May Ave, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Chain selling books and magazines, plus toys and gifts.",
      "poi_long_description": "People say this bookstore offers a huge selection of books, puzzles, music, and toys, and has a Starbucks. They highlight the clean, organized, and quiet atmosphere, and the friendly and helpful staff. They also like the convenient parking and the train table in the kids' section.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-485e-727a-8ae9-018c4aaa6c73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-485e-727a-8ae9-018c4aaa6c73",
        "storage_key": "property/6767906449165607/019d2709-485e-727a-8ae9-018c4aaa6c73.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.barnesandnoble.com/store/2694",
      "poi_directions_map_url": "https://maps.google.com/?cid=986591179468385464&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "barnes--noble",
      "poi_latitude": "35.5331139",
      "poi_longitude": "-97.5647667",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-843-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-758b-725c-97fa-189f44fd803e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-758b-725c-97fa-189f44fd803e",
        "storage_key": "property/6767906449165607/019d2709-758b-725c-97fa-189f44fd803e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvczS4lgasocRuCy_VnMTsQ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_e45acb9a-1b0e-46a5-8e69-06891a422e19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6410 N May Ave, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Casual grocery chain selling organic, gluten-free and vegan foods, plus produce and packaged goods.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, organic foods, and healthy options. They also highlight the friendly and helpful staff, and the clean and well-stocked store.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-47ef-769d-aee1-c03aefa4b4d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-47ef-769d-aee1-c03aefa4b4d3",
        "storage_key": "property/6767906449165607/019d2709-47ef-769d-aee1-c03aefa4b4d3.webp",
        "width": 958,
        "height": 1280
      },
      "poi_business_url": "https://sprouts.com/store/ok/oklahoma-city/oklahoma-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=15265666738450826751&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "35.5374999",
      "poi_longitude": "-97.5647576",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-879-9989",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-752a-70ce-b178-f1c01572d985.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-752a-70ce-b178-f1c01572d985",
        "storage_key": "property/6767906449165607/019d2709-752a-70ce-b178-f1c01572d985.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMSbEc1casocR_4XbhASL2tM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_3c8c7b5b-42b6-490b-bac2-248c6bfa6db9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Southern Nazarene University",
      "poi_type": "Education",
      "poi_address": "6729 NW 39th Expy, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-4898-7788-881f-734bf075cdd7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4898-7788-881f-734bf075cdd7",
        "storage_key": "property/6767906449165607/019d2709-4898-7788-881f-734bf075cdd7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.snu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2990625230431240297&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southern-nazarene-university",
      "poi_latitude": "35.5135594",
      "poi_longitude": "-97.6288124",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-789-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-78d4-742e-bb8e-8412784af5e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-78d4-742e-bb8e-8412784af5e0",
        "storage_key": "property/6767906449165607/019d2709-78d4-742e-bb8e-8412784af5e0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHYsS70IFsocRacAsVM3VgCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_47d53b34-f970-4877-9a41-6e7345d9927e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Patience S. Latting Northwest Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "5600 NW 122nd St, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Modern, welcoming library featuring kid-friendly activities and patios, plus a large selection of books.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-4962-74d9-97ef-d0a6939a3acd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4962-74d9-97ef-d0a6939a3acd",
        "storage_key": "property/6767906449165607/019d2709-4962-74d9-97ef-d0a6939a3acd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=6566230327670178026&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "patience-s-latting-northwest-library---metropolitan-library-system",
      "poi_latitude": "35.5941759",
      "poi_longitude": "-97.6179217",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-606-3580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-78d4-742e-bb8e-8412784af5e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-78d4-742e-bb8e-8412784af5e0",
        "storage_key": "property/6767906449165607/019d2709-78d4-742e-bb8e-8412784af5e0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkacMZVEDsocR6oAtkrHvH1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_0fc6ac7e-694e-40d6-a895-9c72946a3958",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Bethany Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "6700 NW 35th St, Bethany, OK 73008, USA",
      "poi_short_description": "Public library offering kid-friendly activities, meeting rooms, and other resources.",
      "poi_long_description": "People say this public library offers a diverse selection of books and a variety of activities for all ages. They highlight the cozy atmosphere and the availability of meeting rooms. They also like the helpful and attentive staff. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-4d94-7052-8a23-d665ce3811c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4d94-7052-8a23-d665ce3811c5",
        "storage_key": "property/6767906449165607/019d2709-4d94-7052-8a23-d665ce3811c5.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=15531442417609680617&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bethany-library---metropolitan-library-system",
      "poi_latitude": "35.5062789",
      "poi_longitude": "-97.6316452",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-789-8363",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-78d4-742e-bb8e-8412784af5e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-78d4-742e-bb8e-8412784af5e0",
        "storage_key": "property/6767906449165607/019d2709-78d4-742e-bb8e-8412784af5e0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV4NBRVwFsocR6SYP95bEitc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_ebea73a2-43c7-496f-9015-9861420ed144",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Southwestern Christian University",
      "poi_type": "Education",
      "poi_address": "7210 NW 39th Expy, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-4d21-7776-97e4-f85666b79085.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4d21-7776-97e4-f85666b79085",
        "storage_key": "property/6767906449165607/019d2709-4d21-7776-97e4-f85666b79085.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://www.swcu.edu",
      "poi_directions_map_url": "https://maps.google.com/?cid=6939619905505591377&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southwestern-christian-university",
      "poi_latitude": "35.5120221",
      "poi_longitude": "-97.6398185",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-789-7661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-78d4-742e-bb8e-8412784af5e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-78d4-742e-bb8e-8412784af5e0",
        "storage_key": "property/6767906449165607/019d2709-78d4-742e-bb8e-8412784af5e0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAzjOyG4FsocRUQDkT4l7TmA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_61278a1d-4a43-4de5-b911-6490a7cb5fc9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "SNU Football Stadium",
      "poi_type": "Entertainment",
      "poi_address": "Bethany, OK 73008, USA",
      "poi_short_description": "Stadium offering a field and a restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-4d87-734a-b4f5-dc698a41f6a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4d87-734a-b4f5-dc698a41f6a0",
        "storage_key": "property/6767906449165607/019d2709-4d87-734a-b4f5-dc698a41f6a0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://snuathletics.com/facilities/snu-football-stadium/1",
      "poi_directions_map_url": "https://maps.google.com/?cid=14871021148287990153&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "snu-football-stadium",
      "poi_latitude": "35.5210386",
      "poi_longitude": "-97.661832",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-798a-763b-a037-40a362befef4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-798a-763b-a037-40a362befef4",
        "storage_key": "property/6767906449165607/019d2709-798a-763b-a037-40a362befef4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFyihiaEFsocRifkGv_F6YM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_f1721ce4-01eb-4c45-a596-10fa06af8c5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Lake Overholser Iron Bridge",
      "poi_type": "Entertainment",
      "poi_address": "8703-8709 Overholser Dr, Bethany, OK 73008, USA",
      "poi_short_description": "Historic bridge on the former Route 66, still open to traffic, with scenic views.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-4e56-75c6-9a08-0ed49a0e5e39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4e56-75c6-9a08-0ed49a0e5e39",
        "storage_key": "property/6767906449165607/019d2709-4e56-75c6-9a08-0ed49a0e5e39.webp",
        "width": 720,
        "height": 491
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1592759798430792050&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lake-overholser-iron-bridge",
      "poi_latitude": "35.5146149",
      "poi_longitude": "-97.6638523",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7979-775e-ad6b-c8480d33665c",
        "storage_key": "property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlQwMnJkFsocRcnn9DZmeGhY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_2cf34897-2c74-4f83-9d11-d47f177b70f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Oklahoma Museum of Flying",
      "poi_type": "Entertainment",
      "poi_address": "7110 Millionaire Dr, Bethany, OK 73008, USA",
      "poi_short_description": "Volunteer-powered locale for seeing and touching real planes plus learning about their history and mechanics.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-51c6-728f-9b80-e150399d327a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-51c6-728f-9b80-e150399d327a",
        "storage_key": "property/6767906449165607/019d2709-51c6-728f-9b80-e150399d327a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/oklahomamuseumofflying/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7234880537762503548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-museum-of-flying",
      "poi_latitude": "35.5337967",
      "poi_longitude": "-97.6380221",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-79a2-700b-9855-5c4ab5e51d49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-79a2-700b-9855-5c4ab5e51d49",
        "storage_key": "property/6767906449165607/019d2709-79a2-700b-9855-5c4ab5e51d49.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5c3VjhkFsocRfJu4XYR1Z2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_e6990976-dba8-4e9f-99aa-2f1a53c1679f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Pirate Stadium",
      "poi_type": "Entertainment",
      "poi_address": "5300 NW 50th St, Oklahoma City, OK 73122, USA",
      "poi_short_description": "Venue used for graduation, track meets, and games.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-52ad-708e-b828-726e3bb848cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-52ad-708e-b828-726e3bb848cb",
        "storage_key": "property/6767906449165607/019d2709-52ad-708e-b828-726e3bb848cb.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://stadiumconnection.com/ok/stadium.php?id=2852",
      "poi_directions_map_url": "https://maps.google.com/?cid=11523176646670315445&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pirate-stadium",
      "poi_latitude": "35.5216132",
      "poi_longitude": "-97.6066534",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-789-7101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-798a-763b-a037-40a362befef4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-798a-763b-a037-40a362befef4",
        "storage_key": "property/6767906449165607/019d2709-798a-763b-a037-40a362befef4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR1OWhrUasocRtW_clBuM6p8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_384c424c-ca89-4493-9dfb-ff93282d1ec6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Herrick Building and Auditorium - SNU",
      "poi_type": "Entertainment",
      "poi_address": "6749 NW 39th Expy, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-5221-70f8-8eb4-142b861a0117.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5221-70f8-8eb4-142b861a0117",
        "storage_key": "property/6767906449165607/019d2709-5221-70f8-8eb4-142b861a0117.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15681811452994641819&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "herrick-building-and-auditorium---snu",
      "poi_latitude": "35.5123354",
      "poi_longitude": "-97.6304674",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7979-775e-ad6b-c8480d33665c",
        "storage_key": "property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4dCV-0IFsocRm99lQm78oNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_a71253ad-0480-4b11-a13c-91636e5dfa74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Crunch Fitness - Oklahoma City, OK",
      "poi_type": "Health and Wellness",
      "poi_address": "12508 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Gym, part of a chain, offering yoga, cardio and weights rooms, and tanning beds.",
      "poi_long_description": "People say this gym offers a wide variety of group fitness classes, modern equipment, and childcare, and has a friendly and motivating atmosphere.\n\nOther reviews mention membership cancellation can be difficult and there can be hidden fees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-536c-755e-86c5-e57ad5acae4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-536c-755e-86c5-e57ad5acae4b",
        "storage_key": "property/6767906449165607/019d2709-536c-755e-86c5-e57ad5acae4b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/quail-springs",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097941148085874568&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---oklahoma-city-ok",
      "poi_latitude": "35.5969373",
      "poi_longitude": "-97.565988",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-497-8160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7979-775e-ad6b-c8480d33665c",
        "storage_key": "property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8Z8NgOkdsocRiG_leCo9oFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_88ce5c17-7a3e-48df-bfe1-295c1dc60533",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Neel Veterinary Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2700 N MacArthur Blvd, Oklahoma City, OK 73127, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-56d9-739a-89c9-54d2bbbbbf34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-56d9-739a-89c9-54d2bbbbbf34",
        "storage_key": "property/6767906449165607/019d2709-56d9-739a-89c9-54d2bbbbbf34.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://neel.vet/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4132737864806100553&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "neel-veterinary-hospital",
      "poi_latitude": "35.4972708",
      "poi_longitude": "-97.6183664",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-947-8387",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7979-775e-ad6b-c8480d33665c",
        "storage_key": "property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYV66BPkPsocRSe6SHTFvWjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_7d98a8dc-cae8-48a3-9f24-3658d18acd80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4202 Northwest Expy, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Chain gym offering free high-school memberships, plus tanning beds, massage chairs, and TVs.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and workout options, including tanning beds and massage chairs. They also highlight the clean facilities, spacious layout, and convenient location.\n\nSome reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-5742-71a4-abb9-42ea76f2ff37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5742-71a4-abb9-42ea76f2ff37",
        "storage_key": "property/6767906449165607/019d2709-5742-71a4-abb9-42ea76f2ff37.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/oklahoma-city-nw-expressway-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=17337479712866526724&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.5386202",
      "poi_longitude": "-97.5960525",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-242-4141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7979-775e-ad6b-c8480d33665c",
        "storage_key": "property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCWPVatwasocRBGbz4fAZm_A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_cad7912f-d761-4ba8-81f5-1767c3cb7a28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Crunch Fitness - OKC Northwest",
      "poi_type": "Health and Wellness",
      "poi_address": "8490 Northwest Expy, Oklahoma City, OK 73162, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, weight machines, and tanning beds, and provides childcare services.\n\nOther reviews mention the music can be loud and the cancellation policy can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-57c3-759f-a17b-21dcf5e461e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-57c3-759f-a17b-21dcf5e461e6",
        "storage_key": "property/6767906449165607/019d2709-57c3-759f-a17b-21dcf5e461e6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/okc-northwest",
      "poi_directions_map_url": "https://maps.google.com/?cid=6916258324870179385&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---okc-northwest",
      "poi_latitude": "35.56632099999999",
      "poi_longitude": "-97.6628647",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-267-6282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7979-775e-ad6b-c8480d33665c",
        "storage_key": "property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQWtxzOQFsocROaq5dE18-18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8b0dfe30-cf0d-4c70-97f9-326c5089e871",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Colaw Fitness of Oklahoma City Gyms",
      "poi_type": "Health and Wellness",
      "poi_address": "3645 NW 39th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Positive gym, with exercise equipment, tanning beds and massage chairs – plus spiritual wellness.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, tanning beds, and massage chairs. They highlight the affordable membership options, clean facilities, and welcoming atmosphere. They also like the friendly, helpful, and professional staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-5806-768f-8abe-a6eac48db975.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5806-768f-8abe-a6eac48db975",
        "storage_key": "property/6767906449165607/019d2709-5806-768f-8abe-a6eac48db975.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://colawfitness.com/gyms/oklahoma-city-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8355987367554066829&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "colaw-fitness-of-oklahoma-city-gyms",
      "poi_latitude": "35.5128276",
      "poi_longitude": "-97.5823903",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-838-1644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7979-775e-ad6b-c8480d33665c",
        "storage_key": "property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX0nvVDcbsocRjSm2Jj1u9nM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c0d07a56-e1cc-4c14-babb-ecb5a80de6fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "TB Fitness Club",
      "poi_type": "Health and Wellness",
      "poi_address": "3333 W Hefner Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-5bc0-72a8-8f75-777ea1882137.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5bc0-72a8-8f75-777ea1882137",
        "storage_key": "property/6767906449165607/019d2709-5bc0-72a8-8f75-777ea1882137.webp",
        "width": 1280,
        "height": 730
      },
      "poi_business_url": "https://tbfitclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12558554567901756546&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tb-fitness-club",
      "poi_latitude": "35.5816564",
      "poi_longitude": "-97.5782735",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-849-9173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7979-775e-ad6b-c8480d33665c",
        "storage_key": "property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSfqhdqYbsocRgrwkaNfySK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7e4f1d68-dfe4-47ae-807f-a11b63ad7529",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Bethany YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "3400 N Mueller Ave, Bethany, OK 73008, USA",
      "poi_short_description": "Chain fitness center offering amenities such as a pool, basketball courts, and water aerobics classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-5c38-713f-8ad2-4e57552c331c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5c38-713f-8ad2-4e57552c331c",
        "storage_key": "property/6767906449165607/019d2709-5c38-713f-8ad2-4e57552c331c.webp",
        "width": 994,
        "height": 533
      },
      "poi_business_url": "https://ymcaokc.org/branches/bethany/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8306823524238509196&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bethany-ymca",
      "poi_latitude": "35.5051032",
      "poi_longitude": "-97.6316419",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-789-0231",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7979-775e-ad6b-c8480d33665c",
        "storage_key": "property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9wBj710FsocRjEQY3vvDR3M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_12c93eff-9b94-4098-9fcb-798ed0ff1196",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Four Star Fitness - Oklahoma City",
      "poi_type": "Health and Wellness",
      "poi_address": "7013 N May Ave, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Spacious gym featuring weights and cardio equipment, plus personal training.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including dumbbells over 120lbs, Hammer Strength, and Atlantis equipment. They highlight the clean facilities and friendly, helpful staff. They also like the serious and respectful workout environment. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-5d19-706a-8ff3-58b9d8456ab5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5d19-706a-8ff3-58b9d8456ab5",
        "storage_key": "property/6767906449165607/019d2709-5d19-706a-8ff3-58b9d8456ab5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.fourstarfitnessokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17050931711802974728&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "four-star-fitness---oklahoma-city",
      "poi_latitude": "35.54217879999999",
      "poi_longitude": "-97.5664473",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-418-4496",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7979-775e-ad6b-c8480d33665c",
        "storage_key": "property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK6JthFYasocRCKJ1Ww0Uoew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5a1e77d6-df30-457b-a85b-bf548065f9e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Rockwell Plaza YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "8300 Glade Ave, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Clean gym with a basketball court.",
      "poi_long_description": "People say this gym offers a pool and a variety of fitness equipment.\n\nOther reviews mention the staff can be unhelpful and the rules can be strict.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-5cb3-7246-9556-92cf52b9d191.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5cb3-7246-9556-92cf52b9d191",
        "storage_key": "property/6767906449165607/019d2709-5cb3-7246-9556-92cf52b9d191.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ymcaokc.org/branches/rockwell-plaza/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17719347020841965419&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rockwell-plaza-ymca",
      "poi_latitude": "35.5546582",
      "poi_longitude": "-97.6422942",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-621-5858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7979-775e-ad6b-c8480d33665c",
        "storage_key": "property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJleKdJ_AEsocRa1cp_TvE5_U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_04a9612c-1e5b-4e4c-a731-a36e5371e461",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "INTEGRIS Health Baptist Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3300 Northwest Expy, Oklahoma City, OK 73112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-601d-7179-b275-9de6ff2d2312.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-601d-7179-b275-9de6ff2d2312",
        "storage_key": "property/6767906449165607/019d2709-601d-7179-b275-9de6ff2d2312.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://baptist.integrisok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10369483754313068495&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "integris-health-baptist-medical-center",
      "poi_latitude": "35.5290386",
      "poi_longitude": "-97.5764421",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-949-3011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-7c79-7693-838d-19fa5ebfd010.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7c79-7693-838d-19fa5ebfd010",
        "storage_key": "property/6767906449165607/019d2709-7c79-7693-838d-19fa5ebfd010.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJLX5SM_IasocRz68D4IjO548",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_95514e57-5348-4165-9618-4ec6e9df0433",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Mercy Hospital Oklahoma City",
      "poi_type": "Health and Wellness",
      "poi_address": "4300 W Memorial Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-606e-7077-86c7-014b1dfea51e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-606e-7077-86c7-014b1dfea51e",
        "storage_key": "property/6767906449165607/019d2709-606e-7077-86c7-014b1dfea51e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mercy.net/practice/mercy-hospital-oklahoma-city?utm_source=google&utm_medium=organic_search&utm_campaign=yext&utm_term=West&utm_content=website&y_source=1_MTI5OTY2MDItNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=9313836111055257082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mercy-hospital-oklahoma-city",
      "poi_latitude": "35.607198",
      "poi_longitude": "-97.600529",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-755-1515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-7c79-7693-838d-19fa5ebfd010.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7c79-7693-838d-19fa5ebfd010",
        "storage_key": "property/6767906449165607/019d2709-7c79-7693-838d-19fa5ebfd010.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJE-YSHLkcsocR-n2nn5hkQYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_00d933d7-3673-4a5e-97d1-829c3da3e05d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Martin Park Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5000 W Memorial Rd, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Kid-friendly nature preserve with playgrounds and trails, plus deer and turtles.",
      "poi_long_description": "People say this park offers beautiful trails, a playground, and opportunities to see wildlife like deer, turtles, and birds. They highlight the serene and peaceful atmosphere, and the well-maintained grounds. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-6218-7067-a577-1b469276457e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6218-7067-a577-1b469276457e",
        "storage_key": "property/6767906449165607/019d2709-6218-7067-a577-1b469276457e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okc.gov/departments/parks-recreation/martin-park-nature-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=9715724291787303274&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "martin-park-nature-center",
      "poi_latitude": "35.6090059",
      "poi_longitude": "-97.6090052",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-297-1429",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-7d44-70c7-bb9d-68448412990f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7d44-70c7-bb9d-68448412990f",
        "storage_key": "property/6767906449165607/019d2709-7d44-70c7-bb9d-68448412990f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ71CwarQcsocRaqmda8Qv1YY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_172e4987-b568-4104-89bf-81529d2b95aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Will Rogers Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3400 NW 36th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Colorful arboretum featuring disc golf, tennis courts, a greenhouse and picnic sites.",
      "poi_long_description": "People say this botanical garden offers beautiful and well-maintained flower beds with a great variety of plants and flowers. They highlight the free entry and the well-labeled trees, plants, and flowers. They also like the beautiful setting for weddings and quinceañeras.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-6315-73d7-8d9d-6eb34226a469.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6315-73d7-8d9d-6eb34226a469",
        "storage_key": "property/6767906449165607/019d2709-6315-73d7-8d9d-6eb34226a469.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.okc.gov/departments/parks-recreation/will-rogers-gardens",
      "poi_directions_map_url": "https://maps.google.com/?cid=7664107588336218919&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "will-rogers-gardens",
      "poi_latitude": "35.5069148",
      "poi_longitude": "-97.5770745",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-297-1394",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-7d44-70c7-bb9d-68448412990f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7d44-70c7-bb9d-68448412990f",
        "storage_key": "property/6767906449165607/019d2709-7d44-70c7-bb9d-68448412990f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1YeiZYMasocRJ_Mn0z5hXGo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_6680e7d7-a742-4f0e-aed1-d90f5a9182ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Stars And Stripes Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3701 S Lake Hefner Dr, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Relaxed, family-friendly park bordering Lake Hefner offering a skatepark, plus playgrounds.",
      "poi_long_description": "People say this city park offers a large playground, walking trails, and panoramic views of the lake. They highlight the numerous play areas, tables, and BBQ spaces, as well as the decent parking and proximity to the lake. They also like the ability to build sandcastles and watch boats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-655d-7480-a2fd-c3d737e578e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-655d-7480-a2fd-c3d737e578e8",
        "storage_key": "property/6767906449165607/019d2709-655d-7480-a2fd-c3d737e578e8.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/34/2846",
      "poi_directions_map_url": "https://maps.google.com/?cid=16012526237037472583&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stars-and-stripes-park",
      "poi_latitude": "35.5500436",
      "poi_longitude": "-97.5822759",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-297-2756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-7d44-70c7-bb9d-68448412990f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7d44-70c7-bb9d-68448412990f",
        "storage_key": "property/6767906449165607/019d2709-7d44-70c7-bb9d-68448412990f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2tmaBwbsocRR6s9S8brN94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a7678522-f2a6-47cf-bda5-94b365ceaf7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Bluff Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11301 N Meridian Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "A large green space featuring walking trails, picnic spots and a playground.",
      "poi_long_description": "Visitors say this park offers well-maintained walking trails, paved trails, and bike trails, and they praise the abundance of wildlife, especially deer. They also highlight the peaceful atmosphere, ideal for nature walks, jogging, or simply relaxing in the outdoors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-6600-728e-b9ad-2d4a28e59a15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6600-728e-b9ad-2d4a28e59a15",
        "storage_key": "property/6767906449165607/019d2709-6600-728e-b9ad-2d4a28e59a15.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/8/2846",
      "poi_directions_map_url": "https://maps.google.com/?cid=1559565554729670411&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bluff-creek-park",
      "poi_latitude": "35.584442",
      "poi_longitude": "-97.6065873",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-837-7995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-7d44-70c7-bb9d-68448412990f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7d44-70c7-bb9d-68448412990f",
        "storage_key": "property/6767906449165607/019d2709-7d44-70c7-bb9d-68448412990f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh3zaRlYbsocRC9eY7ZuwpBU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5b47cd2e-fef3-4fcc-8721-db580f11deed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Dolese Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5105 NW 50th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Park with picnic tables, a playground, a paved cycling trail, disc golf course, and facilities for baseball and fishing.",
      "poi_long_description": "People say this park offers a disc golf course, trails, a playground, and a pond for fishing. They highlight the beautiful scenery, the well-maintained trails, and the friendly people. They also like the calming atmosphere and the ample space for various activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-670f-71ca-bc90-f5670a280140.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-670f-71ca-bc90-f5670a280140",
        "storage_key": "property/6767906449165607/019d2709-670f-71ca-bc90-f5670a280140.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15736370327146326173&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dolese-park",
      "poi_latitude": "35.52624369999999",
      "poi_longitude": "-97.6055628",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-297-2756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-7d44-70c7-bb9d-68448412990f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7d44-70c7-bb9d-68448412990f",
        "storage_key": "property/6767906449165607/019d2709-7d44-70c7-bb9d-68448412990f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcf9-e8kasocRneiNC3DRYto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8675411a-0c03-49a9-a75b-a153cee1b6ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Wiley Post Airport-PWA",
      "poi_type": "Transportation & Transit",
      "poi_address": "5915 Philip J Rhoads Ave, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-67b2-705a-8584-49d52e1139ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-67b2-705a-8584-49d52e1139ca",
        "storage_key": "property/6767906449165607/019d2709-67b2-705a-8584-49d52e1139ca.webp",
        "width": 1280,
        "height": 1013
      },
      "poi_business_url": "http://www.wileypostairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17919166834402155680&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wiley-post-airport-pwa",
      "poi_latitude": "35.5307445",
      "poi_longitude": "-97.6430208",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-316-4061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-7d93-764d-a307-fa2248f1f643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7d93-764d-a307-fa2248f1f643",
        "storage_key": "property/6767906449165607/019d2709-7d93-764d-a307-fa2248f1f643.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_0-vGAMFsocRoFyAy0urrfg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_a54e1430-3868-43c1-8da3-793fbe2f9f80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Sundance Airport KHSD",
      "poi_type": "Transportation & Transit",
      "poi_address": "13000 N Sara Rd, Yukon, OK 73099, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-69fa-73ea-a67f-436ef209ee6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-69fa-73ea-a67f-436ef209ee6c",
        "storage_key": "property/6767906449165607/019d2709-69fa-73ea-a67f-436ef209ee6c.webp",
        "width": 1280,
        "height": 478
      },
      "poi_business_url": "http://sundanceairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1335938299321620831&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sundance-airport-khsd",
      "poi_latitude": "35.601503",
      "poi_longitude": "-97.7069306",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-373-3886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-7d93-764d-a307-fa2248f1f643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7d93-764d-a307-fa2248f1f643",
        "storage_key": "property/6767906449165607/019d2709-7d93-764d-a307-fa2248f1f643.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6eH4NUUBsocRX5nnHM40ihI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_6b328005-e89d-4d63-a331-e836ca213d99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Jetset FBO",
      "poi_type": "Transportation & Transit",
      "poi_address": "7220 NW 63rd St, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-6adc-7598-937a-9d33058ba9b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6adc-7598-937a-9d33058ba9b7",
        "storage_key": "property/6767906449165607/019d2709-6adc-7598-937a-9d33058ba9b7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.jetsetfbo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=522519284200811341&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jetset-fbo",
      "poi_latitude": "35.5368188",
      "poi_longitude": "-97.6412624",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-888-8684",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-7d93-764d-a307-fa2248f1f643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7d93-764d-a307-fa2248f1f643",
        "storage_key": "property/6767906449165607/019d2709-7d93-764d-a307-fa2248f1f643.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJm1b0wrcFsocRTasUQ4VcQAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_33d605b9-9c71-4e22-8fe5-536e98659af1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Costco Member Service Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14501 Bogert Pkwy, Oklahoma City, OK 73134, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-6d8a-71ce-b7ee-fdf268496061.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6d8a-71ce-b7ee-fdf268496061",
        "storage_key": "property/6767906449165607/019d2709-6d8a-71ce-b7ee-fdf268496061.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3497496067160567460&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "costco-member-service-center",
      "poi_latitude": "35.6183037",
      "poi_longitude": "-97.5748651",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7979-775e-ad6b-c8480d33665c",
        "storage_key": "property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX18i7nkdsocRpG5ufiSaiTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_962a2a8d-1ca4-4d7e-bc33-1969fc9f0897",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Love's South Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2101 Vineyard Blvd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-6cba-7362-bbfc-44c63f8d4e4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6cba-7362-bbfc-44c63f8d4e4b",
        "storage_key": "property/6767906449165607/019d2709-6cba-7362-bbfc-44c63f8d4e4b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4360911662846330364&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-south-building",
      "poi_latitude": "35.5769306",
      "poi_longitude": "-97.5501889",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7979-775e-ad6b-c8480d33665c",
        "storage_key": "property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTfjgpJsbsocR_EXQYA0ShTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_cb0c4c77-f985-4ea1-8384-2a525d103e18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Express Employment International",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9701 Boardwalk Blvd, Oklahoma City, OK 73162, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-6f1a-7309-92fe-e0c26cf0ffc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6f1a-7309-92fe-e0c26cf0ffc9",
        "storage_key": "property/6767906449165607/019d2709-6f1a-7309-92fe-e0c26cf0ffc9.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.expresspros.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=92586903052956857&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "express-employment-international",
      "poi_latitude": "35.56707",
      "poi_longitude": "-97.666693",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-840-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7979-775e-ad6b-c8480d33665c",
        "storage_key": "property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr6z8UW8EsocRuTRTO0zvSAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7791e1b2-4c4e-4da2-96f7-4b1055236aa3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Love's Corporate - Building 50",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3601 NW 63rd St, Oklahoma City, OK 73116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-70b3-71ed-9f0e-691e5584b56e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-70b3-71ed-9f0e-691e5584b56e",
        "storage_key": "property/6767906449165607/019d2709-70b3-71ed-9f0e-691e5584b56e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4599439798442847940&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-corporate---building-50",
      "poi_latitude": "35.5374849",
      "poi_longitude": "-97.5809021",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7979-775e-ad6b-c8480d33665c",
        "storage_key": "property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw8bq4uQasocRxO76tyB-1D8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_badc066b-c3b2-4f3d-8754-982f35f1358f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Pacebutler Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5915 NW 23rd St, Oklahoma City, OK 73127, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-716f-7189-afda-b95ee6c2e8f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-716f-7189-afda-b95ee6c2e8f0",
        "storage_key": "property/6767906449165607/019d2709-716f-7189-afda-b95ee6c2e8f0.webp",
        "width": 500,
        "height": 333
      },
      "poi_business_url": "http://www.pacebutler.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8557959088291269970&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pacebutler-corporation",
      "poi_latitude": "35.4936498",
      "poi_longitude": "-97.6204189",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-755-3131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7979-775e-ad6b-c8480d33665c",
        "storage_key": "property/6767906449165607/019d2709-7979-775e-ad6b-c8480d33665c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEZOm26MesocRUk3t43L6w3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d4d84742-b59a-4bed-a78d-a1f96a09b667",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Spring Creek Elementary School",
      "poi_type": "Education",
      "poi_address": "15400 N Rockwell Ave, Edmond, OK 73013, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.springcreekelementary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16075937260235670256&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "spring-creek-elementary-school",
      "poi_latitude": "35.6271547",
      "poi_longitude": "-97.6372583",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-715-9898",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-56f6-70c0-8f4c-848c975e4f1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-56f6-70c0-8f4c-848c975e4f1f",
        "storage_key": "property/6767906449165607/019cfb41-56f6-70c0-8f4c-848c975e4f1f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjSvZ1x0DsocR8ELQo8MzGd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_b594b5b7-8b26-45d5-b671-df97da4ffefb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Ralph Downs Elementary School",
      "poi_type": "Education",
      "poi_address": "7501 W Hefner Rd, Oklahoma City, OK 73162, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://downs.putnamcityschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17676083283797892376&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ralph-downs-elementary-school",
      "poi_latitude": "35.5809392",
      "poi_longitude": "-97.6464415",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-721-4431",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-56f6-70c0-8f4c-848c975e4f1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-56f6-70c0-8f4c-848c975e4f1f",
        "storage_key": "property/6767906449165607/019cfb41-56f6-70c0-8f4c-848c975e4f1f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-zjDqYQEsocRGF3-PhgQTvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_0ab57525-b440-44f0-ab0b-c7401dd2ce24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Belle Isle Enterprise Middle School, 5th-6th Grade Campus",
      "poi_type": "Education",
      "poi_address": "8400 Greystone Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-3c9d-72b8-86eb-9664272ea0d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3c9d-72b8-86eb-9664272ea0d1",
        "storage_key": "property/6767906449165607/019d7912-3c9d-72b8-86eb-9664272ea0d1.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.okcps.org/BelleIsle",
      "poi_directions_map_url": "https://maps.google.com/?cid=275937612031769942&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "belle-isle-enterprise-middle-school-5th-6th-grade-campus",
      "poi_latitude": "35.5546878",
      "poi_longitude": "-97.5582587",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-587-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-56f6-70c0-8f4c-848c975e4f1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-56f6-70c0-8f4c-848c975e4f1f",
        "storage_key": "property/6767906449165607/019cfb41-56f6-70c0-8f4c-848c975e4f1f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2QvrkIkbsocRVr1S0ctT1AM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_4cf8fa2d-ac4f-44b0-8b13-88934dd85d6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Bethany Middle School",
      "poi_type": "Education",
      "poi_address": "4312 N Mueller Ave, Bethany, OK 73008, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-3c18-746e-b7e0-a5fccd2bd2ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3c18-746e-b7e0-a5fccd2bd2ff",
        "storage_key": "property/6767906449165607/019d7912-3c18-746e-b7e0-a5fccd2bd2ff.webp",
        "width": 1280,
        "height": 747
      },
      "poi_business_url": "https://www.bethanyschools.com/o/bms",
      "poi_directions_map_url": "https://maps.google.com/?cid=15784092697073299913&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bethany-middle-school",
      "poi_latitude": "35.5163314",
      "poi_longitude": "-97.6317841",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-787-3240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-56f6-70c0-8f4c-848c975e4f1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-56f6-70c0-8f4c-848c975e4f1f",
        "storage_key": "property/6767906449165607/019cfb41-56f6-70c0-8f4c-848c975e4f1f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOfrAG0IFsocRyTHkJq5cDNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_c029ebcf-1c80-4150-b5c7-e6219bfed2b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Putnam City North High School",
      "poi_type": "Education",
      "poi_address": "11800 N Rockwell Ave, Oklahoma City, OK 73162, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-3b61-754a-92b8-ad860b3de589.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3b61-754a-92b8-ad860b3de589",
        "storage_key": "property/6767906449165607/019d7912-3b61-754a-92b8-ad860b3de589.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://pcnorth.putnamcityschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10895318835090211107&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "putnam-city-north-high-school",
      "poi_latitude": "35.5891349",
      "poi_longitude": "-97.6368418",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-722-4220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-56f6-70c0-8f4c-848c975e4f1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-56f6-70c0-8f4c-848c975e4f1f",
        "storage_key": "property/6767906449165607/019cfb41-56f6-70c0-8f4c-848c975e4f1f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-ZkjjmADsocRI8EsMMHyM5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_0c9014b3-2307-41d9-8367-9fe3686580c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Bethany High School Baseball Field",
      "poi_type": "Education",
      "poi_address": "6721 NW 42nd Street, Bethany, OK 73008, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-3bff-7610-adf5-3f2ed88d2d5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3bff-7610-adf5-3f2ed88d2d5b",
        "storage_key": "property/6767906449165607/019d7912-3bff-7610-adf5-3f2ed88d2d5b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3410163095491171981&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bethany-high-school-baseball-field",
      "poi_latitude": "35.5198475",
      "poi_longitude": "-97.6605245",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-789-3801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-5712-7683-b6ed-adca4e3af39c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-5712-7683-b6ed-adca4e3af39c",
        "storage_key": "property/6767906449165607/019cfb41-5712-7683-b6ed-adca4e3af39c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN65vA6IFsocRjdblfERVUy8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "custom_f0726fa8-f2a7-435f-8736-9b2122ff3f27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Heritage Hall",
      "poi_type": "Education",
      "poi_address": "1800 NW 122nd St, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-47c9-70f5-8eaf-f7a1270c0bc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-47c9-70f5-8eaf-f7a1270c0bc8",
        "storage_key": "property/6767906449165607/019d7912-47c9-70f5-8eaf-f7a1270c0bc8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.heritagehall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7233749162249664118&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "heritage-hall",
      "poi_latitude": "35.591122",
      "poi_longitude": "-97.542737",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-749-3001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-56f6-70c0-8f4c-848c975e4f1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-56f6-70c0-8f4c-848c975e4f1f",
        "storage_key": "property/6767906449165607/019cfb41-56f6-70c0-8f4c-848c975e4f1f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp_UYSwgcsocRdrYreolwY2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_da8ec3bb-8f62-4c36-84c5-52ba9fc02d28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Casady School",
      "poi_type": "Education",
      "poi_address": "9500 N Pennsylvania Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-489c-7070-8ea0-d3a844a6cedc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-489c-7070-8ea0-d3a844a6cedc",
        "storage_key": "property/6767906449165607/019d7912-489c-7070-8ea0-d3a844a6cedc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.casady.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9825637108673764104&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "casady-school",
      "poi_latitude": "35.568469",
      "poi_longitude": "-97.546406",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-749-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-56f6-70c0-8f4c-848c975e4f1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-56f6-70c0-8f4c-848c975e4f1f",
        "storage_key": "property/6767906449165607/019cfb41-56f6-70c0-8f4c-848c975e4f1f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP8HoKJUbsocRCFtlUuSsW4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_b4a94bc3-cd95-44ed-a853-d722a71bf041",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Oklahoma City Community College - FACE Center",
      "poi_type": "Education",
      "poi_address": "6500 S Land Ave, Oklahoma City, OK 73159, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-4c95-75cc-b0b7-529c8dcecbd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4c95-75cc-b0b7-529c8dcecbd3",
        "storage_key": "property/6767906449165607/019d7912-4c95-75cc-b0b7-529c8dcecbd3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.occc.edu/coe",
      "poi_directions_map_url": "https://maps.google.com/?cid=4367467909320625131&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-city-community-college-face-center",
      "poi_latitude": "35.3995467",
      "poi_longitude": "-97.5719344",
      "poi_miles_from_property": "14.9 mi",
      "poi_walking_minutes": "5 hours 32 mins",
      "poi_biking_minutes": "1 hour 41 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 405-682-7873",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-56f6-70c0-8f4c-848c975e4f1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-56f6-70c0-8f4c-848c975e4f1f",
        "storage_key": "property/6767906449165607/019cfb41-56f6-70c0-8f4c-848c975e4f1f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF-XoeDQSsocR60v5duxcnDw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_0acb0dab-27a6-4fd8-9f2e-5d1951e85267",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Oklahoma City University",
      "poi_type": "Education",
      "poi_address": "2501 N Blackwelder Ave, Oklahoma City, OK 73106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-5183-722c-a1c5-3f1e0fd8e95d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5183-722c-a1c5-3f1e0fd8e95d",
        "storage_key": "property/6767906449165607/019d7912-5183-722c-a1c5-3f1e0fd8e95d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.okcu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=411899583880737593&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-city-university",
      "poi_latitude": "35.4954082",
      "poi_longitude": "-97.540768",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 44 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 405-208-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-56f6-70c0-8f4c-848c975e4f1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-56f6-70c0-8f4c-848c975e4f1f",
        "storage_key": "property/6767906449165607/019cfb41-56f6-70c0-8f4c-848c975e4f1f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJe7zZY6MQsocRObNXPH1ctwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7492db20-9e60-46e3-9334-a29773b41a67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Cajun Corner - Council OKC",
      "poi_type": "Restaurants",
      "poi_address": "9200 N Council Rd ste a, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Counter-serve locale dishing up Cajun specialties such as po' boys and blackened fish, plus beer.",
      "poi_long_description": "People say this Cajun restaurant serves delicious loaded blackened fish, chicken wings, and etouffee. They highlight the generous portions, reasonable prices, and fast service. They also like the friendly staff and comfortable dining experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-5a35-704c-90e7-2cd73b71501f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5a35-704c-90e7-2cd73b71501f",
        "storage_key": "property/6767906449165607/019d7912-5a35-704c-90e7-2cd73b71501f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cajuncornerokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=175148386921407426&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cajun-corner-council-okc",
      "poi_latitude": "35.5641783",
      "poi_longitude": "-97.6556592",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-792-2588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-56f5-70ec-991c-8d712bebdbd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-56f5-70ec-991c-8d712bebdbd9",
        "storage_key": "property/6767906449165607/019cfb41-56f5-70ec-991c-8d712bebdbd9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLybUFmAEsocRwuNuqYdAbgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cajun_restaurant"
    },
    {
      "id": "custom_0ba7fac6-7fa3-49da-9cfe-656f9a4641fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "7101 Northwest Expy, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "Some diners say this cafe offers friendly and professional service.\n\nOther reviews mention the food can be overpriced and portions can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-573c-7337-a6a3-485af3a6a27a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-573c-7337-a6a3-485af3a6a27a",
        "storage_key": "property/6767906449165607/019d7912-573c-7337-a6a3-485af3a6a27a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/ok/oklahoma-city/7101-northwest-expressway-street?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=202540&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=8607398724103759070&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "35.5593741",
      "poi_longitude": "-97.6400782",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-722-0084",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-ba93-7547-9e2c-331e8c3d9376.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-ba93-7547-9e2c-331e8c3d9376",
        "storage_key": "property/6767906449165607/019d7912-ba93-7547-9e2c-331e8c3d9376.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJF7bJEewEsocR3uRaHomfc3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_6ed9f242-ff49-4719-bd39-a0044ebef46f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "8315 N Rockwell Ave, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-585f-722a-91d4-75210908c883.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-585f-722a-91d4-75210908c883",
        "storage_key": "property/6767906449165607/019d7912-585f-722a-91d4-75210908c883.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/12808",
      "poi_directions_map_url": "https://maps.google.com/?cid=3275952508498585922&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "35.55584",
      "poi_longitude": "-97.63958",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-506-6086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-ba93-7547-9e2c-331e8c3d9376.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-ba93-7547-9e2c-331e8c3d9376",
        "storage_key": "property/6767906449165607/019d7912-ba93-7547-9e2c-331e8c3d9376.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJtfrQIO8EsocRQqkbInOFdi0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_423826a1-8027-4775-af6c-43be8facb88f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Eggceptional Cafe",
      "poi_type": "Restaurants",
      "poi_address": "6210 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Homemade breakfast fare (waffles and burritos included) plus lunch items at a relaxed cafe with a covered patio.",
      "poi_long_description": "People say this breakfast restaurant serves delicious cinnamon rolls, waffles, and chicken fried steak. They highlight the generous portions, reasonable prices, and cozy, homey atmosphere. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-60cc-74fd-bf64-44d441118ce0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-60cc-74fd-bf64-44d441118ce0",
        "storage_key": "property/6767906449165607/019d7912-60cc-74fd-bf64-44d441118ce0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sites.google.com/eggceptionalcafe.net/eggceptionalcafe/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=8294575730068253181&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "eggceptional-cafe",
      "poi_latitude": "35.5517873",
      "poi_longitude": "-97.626062",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-730-6462",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-56f5-70ec-991c-8d712bebdbd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-56f5-70ec-991c-8d712bebdbd9",
        "storage_key": "property/6767906449165607/019cfb41-56f5-70ec-991c-8d712bebdbd9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH0-GE4oFsocR_WlLEa5AHHM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_1a840f37-6aba-47b0-8a04-625c4e9d8dcc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "IHOP",
      "poi_type": "Restaurants",
      "poi_address": "7708 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Long-standing chain serving a wide variety of pancakes & other American breakfast & diner fare.",
      "poi_long_description": "People say this breakfast restaurant offers a variety of pancakes, omelets, and breakfast samplers.\n\nOther reviews mention the service can be slow and the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-6952-724a-a567-509d38480699.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-6952-724a-a567-509d38480699",
        "storage_key": "property/6767906449165607/019d7912-6952-724a-a567-509d38480699.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://restaurants.ihop.com/en-us/ok/oklahoma-city/breakfast-7708-nw-expy-1907?utm_source=google&utm_medium=organic&utm_campaign=google_my_business&utm_term=1907&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=7252081589497757449&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ihop",
      "poi_latitude": "35.5628714",
      "poi_longitude": "-97.650954",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-470-1076",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-56f5-70ec-991c-8d712bebdbd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-56f5-70ec-991c-8d712bebdbd9",
        "storage_key": "property/6767906449165607/019cfb41-56f5-70ec-991c-8d712bebdbd9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL9siyPQEsocRCf8pUMiRpGQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_5687935e-70f8-4506-b0d1-c3c65e9ac8d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Cal's Chicago Style Eatery",
      "poi_type": "Restaurants",
      "poi_address": "7005 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Petite restaurant featuring Chicago-style hot dogs, pizzas and sandwiches.",
      "poi_long_description": "People say this restaurant serves delicious Italian beef sandwiches, Chicago dogs, and gyros. They highlight the fresh ingredients, tender beef, and flavorful au jus. They also like the friendly staff and the authentic Chicago-style decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-6c41-739e-b0c0-4e1b7640d4b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-6c41-739e-b0c0-4e1b7640d4b3",
        "storage_key": "property/6767906449165607/019d7912-6c41-739e-b0c0-4e1b7640d4b3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.calschicagoeateryokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13586519042517171839&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cal-s-chicago-style-eatery",
      "poi_latitude": "35.5595564",
      "poi_longitude": "-97.6380766",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-730-6063",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-56f5-70ec-991c-8d712bebdbd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-56f5-70ec-991c-8d712bebdbd9",
        "storage_key": "property/6767906449165607/019cfb41-56f5-70ec-991c-8d712bebdbd9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLT3AnJsEsocRf_5QrxUDjbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c2dfbe64-7259-426b-bd9c-bfbc492ab1d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Louie's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "7216 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Casual hangout with sports on TV & a menu of classic American pub fare.",
      "poi_long_description": "People say this bar and grill offers delicious burgers, wings, and street tacos. They also highlight the friendly and efficient service, and the fun atmosphere.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-76b1-7675-9095-afff4e4a8758.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-76b1-7675-9095-afff4e4a8758",
        "storage_key": "property/6767906449165607/019d7912-76b1-7675-9095-afff4e4a8758.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.louiesgrillandbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=281015741009860937&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "louie-s-grill-bar",
      "poi_latitude": "35.5577993",
      "poi_longitude": "-97.6405298",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-720-1999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-56f5-70ec-991c-904a202d62df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-56f5-70ec-991c-904a202d62df",
        "storage_key": "property/6767906449165607/019cfb41-56f5-70ec-991c-904a202d62df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJladSKewEsocRSZkv21Ne5gM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_7c58c0f7-0b5c-4bfc-83a0-ff0fcf2213ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "QDOBA Mexican Eats",
      "poi_type": "Restaurants",
      "poi_address": "7002 Northwest Expy Suite A, Oklahoma City, OK 73132, USA",
      "poi_short_description": "A menu of customizable Mexican food served in a modern restaurant, plus takeout & catering.",
      "poi_long_description": "People say this Mexican restaurant offers quick service. They also highlight the friendly staff.\n\nOther reviews mention the food can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-79d3-77f6-92b8-5b600ec32801.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-79d3-77f6-92b8-5b600ec32801",
        "storage_key": "property/6767906449165607/019d7912-79d3-77f6-92b8-5b600ec32801.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.qdoba.com/us/ok/oklahoma-city/7002-northwest-expressway?utm_medium=organic&utm_source=google&utm_campaign=google_maps&utm_content=website&utm_term=2619",
      "poi_directions_map_url": "https://maps.google.com/?cid=16223840674653119938&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "qdoba-mexican-eats",
      "poi_latitude": "35.5566082",
      "poi_longitude": "-97.6366959",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-470-7772",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-56f5-70ec-991c-8d712bebdbd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-56f5-70ec-991c-8d712bebdbd9",
        "storage_key": "property/6767906449165607/019cfb41-56f5-70ec-991c-8d712bebdbd9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ27PMR-kEsocRwqU70SKpJuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_d692e0a7-f637-4a37-87fb-d0c2ae472712",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "7004 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken sandwiches, nuggets, and salads. They highlight the food is consistently hot, flavorful, and fresh, and the new Avocado BLT Chicken Sandwich with sriracha-infused bun is a standout. They also like the friendly staff and clean restaurant.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-7ae8-7769-be7e-e8b7876e34ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-7ae8-7769-be7e-e8b7876e34ce",
        "storage_key": "property/6767906449165607/019d7912-7ae8-7769-be7e-e8b7876e34ce.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ok/rockwell-south?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=133001303556522271&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "35.556846",
      "poi_longitude": "-97.6372198",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-728-9494",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-56f5-70ec-991c-8d712bebdbd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-56f5-70ec-991c-8d712bebdbd9",
        "storage_key": "property/6767906449165607/019cfb41-56f5-70ec-991c-8d712bebdbd9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLz6zOOkEsocRH4EmHfuD2AE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_0dd75f9c-46ea-4f39-a3fe-95f5d7c3cfc9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Feast",
      "poi_type": "Restaurants",
      "poi_address": "6512 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Varied Asian & American eats offered buffet-style in a laid-back, modern setting with a sleek bar.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of dishes and the service can be excellent.\n\nOther reviews mention the food can be overcooked and dry.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-84b7-7505-9767-debaa822302a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-84b7-7505-9767-debaa822302a",
        "storage_key": "property/6767906449165607/019d7912-84b7-7505-9767-debaa822302a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/Fuzebuffetbarofficial/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6317205953838795027&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "feast",
      "poi_latitude": "35.5541381",
      "poi_longitude": "-97.630989",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-603-8668",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-56f5-70ec-991c-8d712bebdbd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-56f5-70ec-991c-8d712bebdbd9",
        "storage_key": "property/6767906449165607/019cfb41-56f5-70ec-991c-8d712bebdbd9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAcJNxiobsocRE0mLU1g5q1c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_12a1c032-5ef8-4c1b-9dd4-d026187a1146",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "7800 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Department store offering clothing, toys, and other goods, plus a grocery and a pharmacy.",
      "poi_long_description": "People say this department store offers a wide variety of merchandise and is easy to navigate.\n\nOther reviews mention the service can be unhelpful and the prices can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-87e6-70a1-8bb2-246b21e6f073.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-87e6-70a1-8bb2-246b21e6f073",
        "storage_key": "property/6767906449165607/019d7912-87e6-70a1-8bb2-246b21e6f073.webp",
        "width": 1000,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/622-oklahoma-city-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=72616393302217797&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.5623547",
      "poi_longitude": "-97.6540121",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-773-2625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-5707-713b-8e62-22888d629184.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-5707-713b-8e62-22888d629184",
        "storage_key": "property/6767906449165607/019cfb41-5707-713b-8e62-22888d629184.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQ3LN2ooEsocRRRSmlzn8AQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_6df89ad6-d7da-45d7-8b43-c0641592d292",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "9001 NW Psge, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "People say this department store offers a wide selection of clothing, accessories, and seasonal items, and they like the Sephora inside. They also highlight the friendly and helpful staff, and the clean and well-organized store.\n\nOther reviews mention the Amazon returns can close earlier than the rest of the store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-8d5e-75ba-b643-7a58e2fc7764.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-8d5e-75ba-b643-7a58e2fc7764",
        "storage_key": "property/6767906449165607/019d7912-8d5e-75ba-b643-7a58e2fc7764.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://www.kohls.com/stores/ok/oklahomacity-488.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13701744966133765203&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kohl-s",
      "poi_latitude": "35.5616271",
      "poi_longitude": "-97.651654",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-621-1779",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-5707-713b-8e62-22888d629184.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-5707-713b-8e62-22888d629184",
        "storage_key": "property/6767906449165607/019cfb41-5707-713b-8e62-22888d629184.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgzVq5vQEsocRU1RmpXNgJr4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_30c896d2-9dc7-46c0-b146-129da191ff58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Crest Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "11120 N Rockwell Ave, Oklahoma City, OK 73162, USA",
      "poi_short_description": "Grocery store offering a good selection of produce, meat, and deli items.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, quality meats, and specialty items, and has a good deli and bakery. They also highlight the competitive prices, frequent sales, and clean, well-stocked shelves.\n\nSome reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-8e12-753b-a801-084b55831c38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-8e12-753b-a801-084b55831c38",
        "storage_key": "property/6767906449165607/019d7912-8e12-753b-a801-084b55831c38.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.crestfoodsok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14273686067937202546&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "crest-foods",
      "poi_latitude": "35.5828942",
      "poi_longitude": "-97.6374351",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-709-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-5727-725c-9968-b95850b57f54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-5727-725c-9968-b95850b57f54",
        "storage_key": "property/6767906449165607/019cfb41-5727-725c-9968-b95850b57f54.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnxzFj54EsocRctHWgtpRFsY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_63313ac7-1d81-4819-814b-4165f8c7d9c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "9000 NW Psge, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "People say this warehouse club offers a wide variety of products, including food, clothing, appliances, and more. They also highlight the great prices, especially for bulk purchases, and the convenient Scan & Go app.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-9376-713f-a54b-d37e7d8ff7c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-9376-713f-a54b-d37e7d8ff7c0",
        "storage_key": "property/6767906449165607/019d7912-9376-713f-a54b-d37e7d8ff7c0.webp",
        "width": 1280,
        "height": 923
      },
      "poi_business_url": "https://www.samsclub.com/club/4731-oklahoma-city-ok",
      "poi_directions_map_url": "https://maps.google.com/?cid=13610597017354183618&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sam-s-club",
      "poi_latitude": "35.5604571",
      "poi_longitude": "-97.650454",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-773-3602",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-5707-713b-8e62-22888d629184.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-5707-713b-8e62-22888d629184",
        "storage_key": "property/6767906449165607/019cfb41-5707-713b-8e62-22888d629184.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQ1Coe_QEsocRwiNjEOCN4rw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_077acb69-067a-4129-9829-55fe64dbb3f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Garden Center at The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "7620 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-9364-7648-8219-17f19b9d4b4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-9364-7648-8219-17f19b9d4b4f",
        "storage_key": "property/6767906449165607/019d7912-9364-7648-8219-17f19b9d4b4f.webp",
        "width": 1280,
        "height": 745
      },
      "poi_business_url": "https://www.homedepot.com/l/NW-Oklahoma-City/OK/Oklahoma-City/73132/3909/garden-center?emt=GCGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8963018846873871714&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "garden-center-at-the-home-depot",
      "poi_latitude": "35.5611024",
      "poi_longitude": "-97.6480411",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-773-6077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-5707-713b-8e62-22888d629184.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-5707-713b-8e62-22888d629184",
        "storage_key": "property/6767906449165607/019cfb41-5707-713b-8e62-22888d629184.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJV3yZofMEsocRYmUMMycKY3w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden_center"
    },
    {
      "id": "custom_ddc0517b-346e-4dd5-b4b9-9b1ef242da2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Academy Sports + Outdoors",
      "poi_type": "Shopping & Retail",
      "poi_address": "4261 NW 63rd St, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Sporting goods chain selling athletic apparel & footwear, plus outdoor gear & fitness equipment.",
      "poi_long_description": "People say this sporting goods store offers a wide selection of shoes, apparel, and fishing equipment. They also highlight the friendly and helpful staff, and the clean and well-organized store.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-9692-7749-9397-4e3bbe55c02e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-9692-7749-9397-4e3bbe55c02e",
        "storage_key": "property/6767906449165607/019d7912-9692-7749-9397-4e3bbe55c02e.webp",
        "width": 1137,
        "height": 640
      },
      "poi_business_url": "https://www.academy.com/storelocator/oklahoma/oklahoma-city/store-0086",
      "poi_directions_map_url": "https://maps.google.com/?cid=9132741120885004256&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "academy-sports-outdoors",
      "poi_latitude": "35.5375018",
      "poi_longitude": "-97.5961179",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-767-3720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-5707-713b-8e62-22888d629184.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-5707-713b-8e62-22888d629184",
        "storage_key": "property/6767906449165607/019cfb41-5707-713b-8e62-22888d629184.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJxT7AhNsasocR4Bf0f6kDvn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_c71c9269-c836-4e5b-b574-38e9981fa868",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "5801 N May Ave, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "People say this electronics store offers a wide selection of TVs, laptops, and other electronics. They also highlight the helpful staff and efficient service.\n\nOther reviews mention the phone service can be automated.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-9e36-7570-9322-9c09b1fac467.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-9e36-7570-9322-9c09b1fac467",
        "storage_key": "property/6767906449165607/019d7912-9e36-7570-9322-9c09b1fac467.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://stores.bestbuy.com/ok/oklahoma-city/5801-n-may-ave-220.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=15839067288564721449&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "35.53051300000001",
      "poi_longitude": "-97.566729",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-840-3796",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-5707-713b-8e62-22888d629184.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-5707-713b-8e62-22888d629184",
        "storage_key": "property/6767906449165607/019cfb41-5707-713b-8e62-22888d629184.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIyaWLl8asocRKedorMerz9s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_32dd63d8-3cb5-45e6-8e91-802ae4a0c5f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "T.J. Maxx",
      "poi_type": "Shopping & Retail",
      "poi_address": "8525 N Rockwell Ave, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Retail chain featuring stylish brand-name apparel, shoes & accessories, plus housewares.",
      "poi_long_description": "People say this department store offers a wide variety of unique gift items and fresh gear. They also highlight the reasonable prices and efficient checkout process.\n\nOther reviews mention the store can be overwhelming.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-9ee7-718d-b099-801f9ea10b9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-9ee7-718d-b099-801f9ea10b9e",
        "storage_key": "property/6767906449165607/019d7912-9ee7-718d-b099-801f9ea10b9e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tjmaxx.tjx.com/store/index.jsp",
      "poi_directions_map_url": "https://maps.google.com/?cid=14051267006221368816&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "t-j-maxx",
      "poi_latitude": "35.5572264",
      "poi_longitude": "-97.6421389",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-665-8002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-5707-713b-8e62-22888d629184.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-5707-713b-8e62-22888d629184",
        "storage_key": "property/6767906449165607/019cfb41-5707-713b-8e62-22888d629184.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-X-yrm8EsocR8L39NeUgAMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_e273b75a-f145-4752-92c8-83fd3a6b77d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Ollie's Bargain Outlet",
      "poi_type": "Shopping & Retail",
      "poi_address": "8101 Northwest Expy, Oklahoma City, OK 73162, USA",
      "poi_short_description": "Discount chain carrying a wide range of closeout merchandise, including food, housewares & toys.",
      "poi_long_description": "People say this discount store offers a wide variety of items, including books, arts and crafts, toys, and home goods. They also highlight the great deals, low prices, and fun shopping experience.\n\nOther reviews mention the store can be messy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-a189-7270-8a33-8c6f8eea939e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-a189-7270-8a33-8c6f8eea939e",
        "storage_key": "property/6767906449165607/019d7912-a189-7270-8a33-8c6f8eea939e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ollies.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8269498946471917568&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ollie-s-bargain-outlet",
      "poi_latitude": "35.567706",
      "poi_longitude": "-97.657186",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-498-3083",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-5707-713b-8e62-22888d629184.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-5707-713b-8e62-22888d629184",
        "storage_key": "property/6767906449165607/019cfb41-5707-713b-8e62-22888d629184.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJBceu_zQFsocRAPjsZnopw3I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_d4df3160-31f6-471a-9aac-0f78104e66cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Stinchcomb Wildlife Refuge",
      "poi_type": "Entertainment",
      "poi_address": "5100 N Stinchcomb Ave, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Forested wildlife area for hiking, bird-watching, fishing & biking as well as kayaking.",
      "poi_long_description": "People say this wildlife refuge offers hiking trails, kayaking, and fishing opportunities. They highlight the beautiful scenery, access to the river, and the abundance of wildlife, including birds and snakes. They also like the opportunity to get off in nature and enjoy a peaceful escape.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-a83f-73a8-a021-592d34631fa3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-a83f-73a8-a021-592d34631fa3",
        "storage_key": "property/6767906449165607/019d7912-a83f-73a8-a021-592d34631fa3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.okc.gov/departments/parks-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=16862425980734090786&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "stinchcomb-wildlife-refuge",
      "poi_latitude": "35.5227424",
      "poi_longitude": "-97.6633716",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-297-3882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-570b-73dd-b782-0ffee3611cea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-570b-73dd-b782-0ffee3611cea",
        "storage_key": "property/6767906449165607/019cfb41-570b-73dd-b782-0ffee3611cea.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ85Pzk84FsocRIi75qBZfA-o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wildlife_refuge"
    },
    {
      "id": "custom_61b582ca-7f41-4d0e-bf89-df76b008d714",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Scenic View Lake Hefner",
      "poi_type": "Entertainment",
      "poi_address": "9688-9904 W Lakeshore Dr, Oklahoma City, OK 73162, USA",
      "poi_short_description": "Scenic spot that some visitors say is cool.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-aa0d-740e-8815-e31e5baed9c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-aa0d-740e-8815-e31e5baed9c0",
        "storage_key": "property/6767906449165607/019d7912-aa0d-740e-8815-e31e5baed9c0.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9096596638922898578&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "scenic-view-lake-hefner",
      "poi_latitude": "35.573417",
      "poi_longitude": "-97.6158049",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-570b-73dd-b782-0ffee3611cea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-570b-73dd-b782-0ffee3611cea",
        "storage_key": "property/6767906449165607/019cfb41-570b-73dd-b782-0ffee3611cea.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcaHcT7IEsocRkvwCgHKaPX4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_494f4da3-3ff3-46fc-94a9-028b52058e9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "National Cowboy & Western Heritage Museum",
      "poi_type": "Entertainment",
      "poi_address": "1700 NE 63rd St, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Dioramas, artifacts, art & more documenting & interpreting the history of the American West.",
      "poi_long_description": "People say this heritage museum offers a vast collection of Western art, artifacts, and historical exhibits, including sculptures, paintings, clothing, and personal items from historical figures. They highlight the educational and family-friendly atmosphere, with engaging multi-media displays, outdoor exhibits, and a playground. They also like the friendly and knowledgeable staff, and the informative presentations by docents. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-ab03-74fa-aff7-c7edb0a59028.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-ab03-74fa-aff7-c7edb0a59028",
        "storage_key": "property/6767906449165607/019d7912-ab03-74fa-aff7-c7edb0a59028.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://nationalcowboymuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4849781199640138445&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "national-cowboy-western-heritage-museum",
      "poi_latitude": "35.5356997",
      "poi_longitude": "-97.4831286",
      "poi_miles_from_property": "11.4 mi",
      "poi_walking_minutes": "4 hours 15 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 405-478-2250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-5713-71e5-ae2f-28f2f3321461.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-5713-71e5-ae2f-28f2f3321461",
        "storage_key": "property/6767906449165607/019cfb41-5713-71e5-ae2f-28f2f3321461.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ-cenbQZsocRzRLrSk7iTUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_5ea5e96a-8a34-40fa-b54d-50f1e3e437fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Oklahoma City Zoo",
      "poi_type": "Entertainment",
      "poi_address": "2000 Remington Pl, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Zoo with an array of animals, plus walking trails, shows & attractions such as train tours.",
      "poi_long_description": "Visitors say this zoo offers a wide variety of animals, including elephants, giraffes, stingrays, and a petting zoo, with fun activities like giraffe feeding and a splash pad. They also highlight the friendly and helpful staff, the clean and well-maintained facilities, and the affordable prices, especially with discounts for families and military members.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-b0bd-7720-8edf-50696e5be7f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b0bd-7720-8edf-50696e5be7f9",
        "storage_key": "property/6767906449165607/019d7912-b0bd-7720-8edf-50696e5be7f9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://okczoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5013321368135377402&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-city-zoo",
      "poi_latitude": "35.5238895",
      "poi_longitude": "-97.4724932",
      "poi_miles_from_property": "12.0 mi",
      "poi_walking_minutes": "4 hours 32 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 405-424-3344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-5712-7683-b6ed-adca4e3af39c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-5712-7683-b6ed-adca4e3af39c",
        "storage_key": "property/6767906449165607/019cfb41-5712-7683-b6ed-adca4e3af39c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg_EZ4YPguocR-qGV_DjlkkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_77fa8cc7-17dc-4eab-a871-c6ca1f49d5a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "poi_name": "Science Museum Oklahoma",
      "poi_type": "Entertainment",
      "poi_address": "2020 Remington Pl, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Expansive museum with child-friendly, hands-on exhibits, plus a planetarium & cafe.",
      "poi_long_description": "People say this science museum offers a wide variety of fun, interactive exhibits and activities, including a planetarium and a slanted room. They highlight the educational value, the engaging live shows, and the spacious layout that prevents overcrowding. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019d7912-b3fd-727f-b9f8-b603f283615b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b3fd-727f-b9f8-b603f283615b",
        "storage_key": "property/6767906449165607/019d7912-b3fd-727f-b9f8-b603f283615b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.sciencemuseumok.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11678503685854338412&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "science-museum-oklahoma",
      "poi_latitude": "35.5237553",
      "poi_longitude": "-97.4754913",
      "poi_miles_from_property": "11.7 mi",
      "poi_walking_minutes": "4 hours 25 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 405-602-6664",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-5713-71e5-ae2f-28f2f3321461.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-5713-71e5-ae2f-28f2f3321461",
        "storage_key": "property/6767906449165607/019cfb41-5713-71e5-ae2f-28f2f3321461.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJMTLOFjEYsocRbB1wFzphEqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    }
  ],
  "office_hours": [
    {
      "id": "ec_1368482e69e6d0fb279be013",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_4d75fdf28bd113963f6d1afc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_5abd4459ffe2aac0d0f69535",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_31fbab5119d45c7d5e1f91ed",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_5085f990c32287e4805847e8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_8286b593-6328-49fd-bf45-86e28bd1b973",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "rating": "5.0",
      "name": "Ferol Sellon",
      "text": "By far my best choice  in 15 years and dozens of renting experiences. Came from The Retreat, so not hard to do better. However, this 1-bd has blown all the rest out of the water! Beautiful, spacious, so many ways to customize. Application process was quick and painless. Ac went out and was fixed within 48 hours. Could have been less had i said something quicker, whereas The Retreat took SIX WEEKS. The tenants rarely pick up their dogs 💩, but the staff is on it daily! *shame on you, dog owners* This place ACTUALLY has security, where The Retreat lies and doesn't have one. Neighbors are kind and considerate, minus one or two here and there (fighting couples, typical). Water isn't shut off 2-5/wk like next door. Place is nicely insulated and wired. $100k renters insurance isn't required, though any is recommended. Pool is open and CLEAN as advertised. You guessed it- unlike The Retreat. Leases are respected, emails and calls are returned, packages aren't stolen from the office. Mail room and wash room are secured and kept up with. Both the office ladies have been so very kind and attentive. Parking spots vary in size and can be a bit tight, but everyone seems to have an unspoken understanding to give space. Maintenance doesnt dump their trash or repair debris throughout the apartment/walk ways/the grounds, unlike next door. Overall, come rent with Hunters Ridge, yall! The app makes paying rent so easy. AND their utility bill doesn't run 100-300$ like The Retreat. I average $50 a month. 1-bd with utility runs me $900, not 1100-1300 for a slum!",
      "date": "2025-09-21",
      "title": ""
    },
    {
      "id": "custom_f3f7ee0d-6a24-472d-b6f9-9ef1b61f9b4f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "rating": "5.0",
      "name": "H Derdeyn",
      "text": "Like the rest of the real tenanrs, we regretted leasing from The Retreat at Riverbend from day one - no water, no ac, absolutely filthy, doors broken in half, urine and rust stained carpet, unsealed toilet rotted out, holes in the walls and shower, mold and earwig infested, list goes on - to the point of leaving three months early *still paid, tho, dont worry* to come to Hunters Ridge. Been here 5 months and am not disappointed at all.",
      "date": "2025-09-21",
      "title": ""
    },
    {
      "id": "custom_123c801b-854e-41f6-9d76-9f9f0476d44f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "rating": "5.0",
      "name": "Bob Saget",
      "text": "10/10 price, staff, maintenance, grounds, pool, all the works! And they dont have to incentivize their tenants, friends, family or lawn workers to leave false good reviews 👀 looking at you 8108 w britton",
      "date": "2025-09-21",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_0cd4306a-ef8f-4d6d-8eb5-e832ac277301",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb42-170d-723a-8087-9047781c6cbe.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of the apartment complex outdoor swimming pool and lounge chairs.",
        "public_id": "019cfb42-170d-723a-8087-9047781c6cbe",
        "storage_key": "property/6767906449165607/019cfb42-170d-723a-8087-9047781c6cbe.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Virtual Tour Hunter’s Ridge Apartments",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f97ff7baa193c3409932a86&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-3795-71aa-a40b-5ac811e8d3a3",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "hunter's-ridge-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607"
    },
    {
      "lead_collector_id": "019cf79e-380a-775c-811e-aead8964ed3b",
      "lead_source": "LANDING_PAGE",
      "name": "hunter's-ridge-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "generator",
      "page_item_url": "apartments-with-pool-oklahoma-city-ridge",
      "search_query": "apartments with pool oklahoma city",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Oklahoma City",
      "h2_subtitle": "Discover the joy of living in one of the finest apartments with pool in Oklahoma City. Hunter's Ridge Apts. offers amenities that fit your lifestyle.",
      "page_copy": "At Hunter's Ridge Apts., you'll love our combination of modern living with stellar amenities, including an inviting pool ideal for relaxation. Our vibrant Oklahoma City community offers spacious one and two-bedroom floor plans, designed with your comfort in mind. Whether lounging poolside or enjoying the welcoming clubhouse, our facilities ensure both recreation and relaxation right at your doorstep. \n\nLocated in the lively Northridge neighborhood, Hunter's Ridge Apts. provides more than just apartments with pool in Oklahoma City; it offers a community and lifestyle. Enjoy the convenience of having a dedicated property manager on-site, and benefit from amenities like a fully-equipped kitchen, in-unit washer/dryer hookups, and much more. Perfectly balancing comfort and convenience, it's the ideal place to call home. Schedule a tour and see the difference today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a spa.",
        "public_id": "019cfb41-34a3-71ee-b967-565268701afb",
        "storage_key": "property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Oklahoma City",
      "seo_description": "Discover Hunter's Ridge Apts. in Oklahoma City with pool, clubhouse, and more. Find your perfect home today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-northridge-ridge",
      "search_query": "in-unit laundry apartments near northridge",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apts Near Northridge",
      "h2_subtitle": "Explore in-unit laundry apartments near Northridge at Hunter's Ridge. Enjoy convenience and comfort in Oklahoma City.",
      "page_copy": "Hunter's Ridge Apts. offers the ultimate convenience with in-unit laundry options in our spacious apartments near Northridge. Located in vibrant Oklahoma City, our one and two-bedroom homes are thoughtfully designed with features that make life easier. With washer/dryer hookups available in every unit, you can enjoy the comfort of doing laundry from the privacy of your own home—a true time-saver.\n\nSituated in the appealing Northridge neighborhood, our community combines comfort with convenience. Beyond in-unit laundry, residents can indulge in delightful amenities like a refreshing pool, a welcoming clubhouse, and lush picnic areas. With a property manager on site and a kitchen equipped with essential appliances, Hunter's Ridge Apts. is perfect for those seeking a welcoming and practical living environment. Visit us today to see firsthand the benefits of residing at Hunter's Ridge!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a spa.",
        "public_id": "019cfb41-34a3-71ee-b967-565268701afb",
        "storage_key": "property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apts Near Northridge",
      "seo_description": "Hunter's Ridge Apts. offers in-unit laundry near Northridge, Oklahoma City. Experience the convenience and comfort today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "generator",
      "page_item_url": "oklahoma-city-apts-with-air-conditioning",
      "search_query": "oklahoma city apartments with air conditioning",
      "category": "Amenity",
      "h1_title": "OKC Apartments with Air Conditioning",
      "h2_subtitle": "Find Oklahoma City apartments with air conditioning at Hunter's Ridge. Experience ultimate comfort with modern amenities and conveniences.",
      "page_copy": "Hunter's Ridge Apts. combines comfort with convenience, offering Oklahoma City apartments with air conditioning tailored to your lifestyle. Our one and two-bedroom floor plans ensure year-round climate control, making them perfect for Oklahoma's fluctuating temperatures. Situated in the lively Northridge neighborhood, our community enhances the quality of life with modern amenities designed for everyone.\n\nResidents at Hunter's Ridge Apts. enjoy more than just air conditioning. Dive into our refreshing pool, gather at the welcoming clubhouse, or host outdoor fun in our designated picnic areas. With a property manager on site and essential in-house features like a fully-equipped kitchen and washer/dryer hookups, living in Oklahoma City becomes a breeze. Discover the perfect harmony of maintenance-free living with all the desired comforts at Hunter's Ridge. Schedule a visit today to experience it for yourself!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a spa.",
        "public_id": "019cfb41-34a3-71ee-b967-565268701afb",
        "storage_key": "property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "OKC Apartments with Air Conditioning",
      "seo_description": "Discover air-conditioned apartments at Hunter's Ridge in Oklahoma City. Enjoy comfort with modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "generator",
      "page_item_url": "hunters-ridge-apartments-with-dishwasher",
      "search_query": "hunter's ridge apartments with dishwasher",
      "category": "Amenity",
      "h1_title": "Hunter's Ridge Apts with Dishwasher",
      "h2_subtitle": "Explore Hunter's Ridge Apts with dishwasher in Oklahoma City. Enjoy modern conveniences and a vibrant community in Northridge.",
      "page_copy": "At Hunter's Ridge Apts., we make everyday living convenient with in-apartment dishwashers designed to simplify your routine. Located in Oklahoma City's vibrant Northridge neighborhood, our one and two-bedroom floor plans are thoughtfully designed to accommodate your lifestyle needs. Enjoy hassle-free meal cleanups and more time for leisure in our community.\n\nBeyond the convenience of having a dishwasher, Hunter's Ridge Apts. offers a suite of amenities including a refreshing pool, a friendly clubhouse for gatherings, and relaxing picnic areas. With a property manager on site and in-unit conveniences like washer/dryer hookups and a fully-equipped kitchen, our community offers a comfortable and modern living experience. Experience the ease and joy of living at Hunter's Ridge by scheduling a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a spa.",
        "public_id": "019cfb41-34a3-71ee-b967-565268701afb",
        "storage_key": "property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hunter's Ridge Apts with Dishwasher",
      "seo_description": "Find Hunter's Ridge Apts in Oklahoma City with dishwasher and more. Enjoy modern living near Northridge!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-okc-73132",
      "search_query": "pet friendly apartments oklahoma city 73132",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apts in OKC 73132",
      "h2_subtitle": "Discover pet-friendly apartments in Oklahoma City, 73132, at Hunter's Ridge. Perfect for you and your furry companions.",
      "page_copy": "Hunter's Ridge Apts. is the perfect place for pet lovers seeking pet-friendly apartments in Oklahoma City's 73132 zip code. Nestled in the welcoming Northridge neighborhood, our community provides the ideal home for you and your furry companions. Our one and two-bedroom floor plans offer ample space and comfort for all residents, whether two-legged or four.\n\nAt Hunter's Ridge Apts., both pets and their owners can enjoy a range of amenities. With a refreshing pool, inviting clubhouse, and serene picnic areas, there's plenty of relaxation and recreation available. Plus, with a property manager on site and in-unit features like well-equipped kitchens and washer/dryer hookups, you'll find Hunter's Ridge a perfect fit for modern, pet-friendly living. Visit us today to explore your new home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a spa.",
        "public_id": "019cfb41-34a3-71ee-b967-565268701afb",
        "storage_key": "property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apts in OKC 73132",
      "seo_description": "Find pet-friendly apartments at Hunter's Ridge in OKC, 73132. Ideal living space for you and your furry friends.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-near-northridge-okc",
      "search_query": "1 bedroom apartments near Northridge OKC",
      "category": "Floorplan",
      "h1_title": "1-Bedroom Apts Near Northridge OKC",
      "h2_subtitle": "Discover 1-bedroom apartments near Northridge, OKC at Hunter's Ridge. Perfectly designed for a comfortable lifestyle.",
      "page_copy": "If you're searching for 1-bedroom apartments near Northridge, OKC, look no further than Hunter's Ridge Apts. Our community, nestled in the vibrant surroundings of Oklahoma City, offers beautifully crafted one-bedroom layouts ideal for anyone craving a comfortable and modern living space. Each apartment is designed with thoughtful details, including kitchens with essential appliances and washer/dryer hookups.\n\nHunter's Ridge prides itself on more than just great apartments. As part of our community, residents enjoy a refreshing pool, a sociable clubhouse, and lovely picnic areas perfect for relaxation and socializing. With a dedicated property manager on site, we ensure that all your needs are promptly met. Come by and explore how Hunter's Ridge can become your perfect 1-bedroom home near Northridge!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a spa.",
        "public_id": "019cfb41-34a3-71ee-b967-565268701afb",
        "storage_key": "property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1-Bedroom Apts Near Northridge OKC",
      "seo_description": "Explore Hunter's Ridge for 1-bedroom apartments near Northridge, OKC. Find the perfect mix of comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-oklahoma-city-73132",
      "search_query": "2 bedroom apartments Oklahoma City 73132",
      "category": "Floorplan",
      "h1_title": "2-Bedroom Apts in OKC 73132",
      "h2_subtitle": "Find spacious 2-bedroom apartments in Oklahoma City 73132 at Hunter's Ridge. Ideal for families seeking comfort and style.",
      "page_copy": "Hunter's Ridge Apts., located in the heart of Oklahoma City 73132, offers exceptional 2-bedroom apartments that provide ample room for families or roommates. Our apartments are carefully designed to combine comfort and functionality, making them perfect for those seeking a stylish yet practical living space in the Northridge area.\n\nResidents enjoy access to a range of amenities that enhance the living experience, such as a large pool for relaxing on hot days, a vibrant clubhouse for social gatherings, and picnic areas for a casual outing. Each apartment comes equipped with convenient features like a kitchen with modern appliances and washer/dryer hookups, ensuring all your lifestyle needs are met. Visit Hunter's Ridge today and see why our 2-bedroom homes are the perfect choice for living in OKC!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a spa.",
        "public_id": "019cfb41-34a3-71ee-b967-565268701afb",
        "storage_key": "property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2-Bedroom Apts in OKC 73132",
      "seo_description": "Discover Hunter's Ridge for spacious 2-bedroom apartments in Oklahoma City 73132. Perfect blend of comfort and convenience!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "generator",
      "page_item_url": "apartments-near-southern-nazarene-university-okc",
      "search_query": "apartments near southern nazarene university okc",
      "category": "School",
      "h1_title": "Apts Near Southern Nazarene University",
      "h2_subtitle": "Discover ideal apartments near Southern Nazarene University at Hunter's Ridge, just a short drive away in Oklahoma City.",
      "page_copy": "For those attending or working at Southern Nazarene University, finding a convenient and comfortable living space is crucial. Hunter's Ridge Apts. offers the perfect solution with our welcoming community situated in Oklahoma City, within easy commuting distance. Our one and two-bedroom layouts provide flexible options that suit various lifestyles, making it an excellent choice for students and faculty alike.\n\nHunter's Ridge ensures you enjoy more than just a place to stay. Our community features a host of amenities including a refreshing pool, a friendly clubhouse, and inviting picnic spots, adding to the overall living experience. Each apartment is equipped with modern conveniences like in-unit washer/dryer hookups and fully appointed kitchens. Discover the harmonious blend of convenience, comfort, and proximity at Hunter's Ridge, just a quick journey from Southern Nazarene University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a spa.",
        "public_id": "019cfb41-34a3-71ee-b967-565268701afb",
        "storage_key": "property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Southern Nazarene University",
      "seo_description": "Find convenient apartments near Southern Nazarene University at Hunter's Ridge, OKC. Perfect for students and faculty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "generator",
      "page_item_url": "apartments-close-to-southwestern-christian-university-nw-okc",
      "search_query": "apartments close to southwestern christian university northwest okc",
      "category": "School",
      "h1_title": "Apts Close to Southwestern Christian University",
      "h2_subtitle": "Discover excellent apartments close to Southwestern Christian University in Northwest OKC at Hunter's Ridge. Perfect for students and staff!",
      "page_copy": "Hunter's Ridge Apts. offers ideal living options for those looking for apartments close to Southwestern Christian University in the vibrant area of Northwest OKC. Our community features thoughtfully designed one and two-bedroom floor plans that accommodate both students and faculty, providing a homey and convenient living environment.\n\nLocated just a short drive from the university, Hunter's Ridge provides a balance between academic life and relaxation. Residents enjoy access to amenities such as a sparkling pool, a welcoming clubhouse for social interactions, and picnic areas perfect for outdoor meals. Each apartment includes modern conveniences like washer/dryer hookups and fully equipped kitchens, making it an exceptional choice for anyone connected to Southwestern Christian University. Experience the charm of Hunter's Ridge today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a spa.",
        "public_id": "019cfb41-34a3-71ee-b967-565268701afb",
        "storage_key": "property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Southwestern Christian University",
      "seo_description": "Explore Hunter's Ridge for apartments close to Southwestern Christian University in NW OKC. Ideal for students and faculty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "generator",
      "page_item_url": "apartments-near-integris-health-baptist-medical-center-okc",
      "search_query": "apartments near INTEGRIS Health Baptist Medical Center OKC",
      "category": "Hospital",
      "h1_title": "Apts Near INTEGRIS Health Baptist Medical Center",
      "h2_subtitle": "Find convenient apartments near INTEGRIS Health Baptist Medical Center in OKC. Hunter's Ridge offers comfort and proximity.",
      "page_copy": "Located strategically in Oklahoma City, Hunter's Ridge Apts. presents an excellent option for those seeking apartments near INTEGRIS Health Baptist Medical Center. If you're a healthcare professional or a visitor needing temporary accommodation, our well-appointed one and two-bedroom floor plans cater to various needs, ensuring a comfortable residence close to the medical center.\n\nEnjoy amenities that enhance your lifestyle, including a serene pool, a community clubhouse perfect for relaxing after a long day, and picnic spots for leisurely breaks. Each apartment offers modern features such as kitchen facilities and washer/dryer hookups, providing convenience and comfort. Make Hunter's Ridge your home and benefit from its ideal location near INTEGRIS Health Baptist Medical Center in OKC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a spa.",
        "public_id": "019cfb41-34a3-71ee-b967-565268701afb",
        "storage_key": "property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near INTEGRIS Health Baptist Medical Center",
      "seo_description": "Hunter's Ridge offers comfortable and convenient apartments near INTEGRIS Health Baptist Medical Center in OKC. Perfect for healthcare professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "generator",
      "page_item_url": "hunters-ridge-apts-close-to-mercy-hospital-okc",
      "search_query": "Hunter's Ridge Apts close to Mercy Hospital Oklahoma City",
      "category": "Hospital",
      "h1_title": "Hunter's Ridge Apts Near Mercy Hospital OKC",
      "h2_subtitle": "Discover Hunter's Ridge Apts located conveniently close to Mercy Hospital Oklahoma City. Ideal for professionals and visitors alike.",
      "page_copy": "Hunter's Ridge Apts. offers a prime location for those looking for residences near Mercy Hospital Oklahoma City. Our thoughtfully designed one and two-bedroom floor plans make Hunter's Ridge a friendly choice for medical professionals, patients, and families who need proximity and comfort. \n\nExperience a range of enjoyable amenities such as our refreshing pool, a community clubhouse perfect for unwinding, and convenient picnic spots. Each apartment is well-equipped with modern conveniences, including a fully functioning kitchen and washer/dryer hookups, providing a hassle-free living experience. Make life easier by choosing Hunter's Ridge Apts, conveniently located close to Mercy Hospital in OKC, ensuring you're never far from where you need to be.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a spa.",
        "public_id": "019cfb41-34a3-71ee-b967-565268701afb",
        "storage_key": "property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hunter's Ridge Apts Near Mercy Hospital OKC",
      "seo_description": "Choose Hunter's Ridge Apts for comfort and convenience near Mercy Hospital Oklahoma City. Perfect for healthcare professionals and visitors.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "generator",
      "page_item_url": "apartments-near-martin-park-nature-center-oklahoma-city",
      "search_query": "apartments near martin park nature center oklahoma city",
      "category": "Park",
      "h1_title": "Apts Near Martin Park Nature Center OKC",
      "h2_subtitle": "Discover serene apartments near Martin Park Nature Center in Oklahoma City. Enjoy nature's beauty just steps away from your home at Hunter's Ridge.",
      "page_copy": "Hunter's Ridge Apts. offers an outstanding location for nature enthusiasts seeking apartments near Martin Park Nature Center in Oklahoma City. Our community is perfect for residents who appreciate serene natural beauty while maintaining easy access to urban conveniences. \n\nChoose from our one and two-bedroom floor plans that offer comfort and style, complemented by delightful amenities such as a refreshing pool and a community clubhouse. Our picnic areas provide a perfect outdoor relaxation space, and each apartment is equipped with modern conveniences like a kitchen and washer/dryer hookups, making it a fantastic choice for those who love being close to Martin Park Nature Center. Explore the peaceful surroundings and vibrant community that Hunter's Ridge has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a spa.",
        "public_id": "019cfb41-34a3-71ee-b967-565268701afb",
        "storage_key": "property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Martin Park Nature Center OKC",
      "seo_description": "Live at Hunter's Ridge, where Oklahoma City's Martin Park Nature Center is right at your doorstep. Perfect apartments for nature lovers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "generator",
      "page_item_url": "hunters-ridge-apts-close-to-will-rogers-gardens-okc",
      "search_query": "hunter's ridge apts close to will rogers gardens okc",
      "category": "Park",
      "h1_title": "Hunter's Ridge Apts Near Will Rogers Gardens",
      "h2_subtitle": "Explore the beauty of Will Rogers Gardens from your new home at Hunter's Ridge Apts. Enjoy convenience and tranquility close by in Oklahoma City.",
      "page_copy": "For those who cherish natural beauty and a peaceful atmosphere, Hunter's Ridge Apts. provides the ideal location close to Will Rogers Gardens in Oklahoma City. Located just a short drive away, our community offers residents easy access to the lush landscapes and vibrant displays that make the gardens a local treasure.\n\nHunter's Ridge features thoughtfully designed one and two-bedroom apartments equipped with modern conveniences like fully outfitted kitchens and washer/dryer hookups. Complementing this are community amenities such as a refreshing pool and welcoming clubhouse, perfect for relaxation. Enjoy the advantage of living near Will Rogers Gardens with the convenience and comfort that Hunter's Ridge Apts. has to provide, offering an exceptional living experience in OKC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a spa.",
        "public_id": "019cfb41-34a3-71ee-b967-565268701afb",
        "storage_key": "property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hunter's Ridge Apts Near Will Rogers Gardens",
      "seo_description": "Experience the tranquility of Will Rogers Gardens right near your home at Hunter's Ridge Apts. in OKC. Perfect blend of comfort and nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "generator",
      "page_item_url": "northridge-apartments-near-stars-and-stripes-park",
      "search_query": "northridge neighborhood apartments stars and stripes park",
      "category": "Park",
      "h1_title": "Northridge Apts Near Stars and Stripes Park",
      "h2_subtitle": "Experience the best of the Northridge neighborhood with apartments near the scenic Stars and Stripes Park in Oklahoma City.",
      "page_copy": "Hunter's Ridge Apts, situated in the welcoming Northridge neighborhood, offers an ideal living option for those interested in apartments near Stars and Stripes Park. This vibrant community in Oklahoma City combines natural beauty with modern convenience, making it a favorite for those seeking an active lifestyle.\n\nOur one and two-bedroom apartments cater to various living needs and preferences. Residents can enjoy amenities like a refreshing pool and a spacious clubhouse, perfect for social gatherings and relaxation. Each apartment is equipped with kitchen essentials and washer/dryer hookups, ensuring a seamless living experience. Whether you're looking to enjoy a day at the park or relax in your comfortable apartment, Hunter's Ridge in the Northridge neighborhood provides a perfect home base.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a spa.",
        "public_id": "019cfb41-34a3-71ee-b967-565268701afb",
        "storage_key": "property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Northridge Apts Near Stars and Stripes Park",
      "seo_description": "Find the perfect apartment in Oklahoma City's Northridge neighborhood, near the beautiful Stars and Stripes Park at Hunter's Ridge.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "generator",
      "page_item_url": "oklahoma-city-apartments-near-bluff-creek-park",
      "search_query": "oklahoma city apts near bluff creek park",
      "category": "Park",
      "h1_title": "OKC Apts Near Bluff Creek Park",
      "h2_subtitle": "Discover tranquil living in Oklahoma City with apartments near Bluff Creek Park. Enjoy nature and convenience at Hunter's Ridge Apts.",
      "page_copy": "At Hunter's Ridge Apts., experience serene living in Oklahoma City with the added benefit of being near Bluff Creek Park. Our community is a perfect choice for residents who love outdoor activities, offering easy access to the park's scenic trails and natural beauty. \n\nOur one and two-bedroom apartments are designed for comfort and convenience, featuring amenities like a refreshing pool, community clubhouse, and picnic areas. Each apartment comes with a modern kitchen and washer/dryer hookups, creating a welcoming environment. Enjoy the best of both worlds with natural escapes at Bluff Creek Park and comfortable living at Hunter's Ridge Apts. in Oklahoma City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a spa.",
        "public_id": "019cfb41-34a3-71ee-b967-565268701afb",
        "storage_key": "property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "OKC Apts Near Bluff Creek Park",
      "seo_description": "Live near the scenic Bluff Creek Park in Oklahoma City. Hunter's Ridge offers the perfect mix of nature and modern living in our apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165607",
      "source": "generator",
      "page_item_url": "hunters-ridge-okc-near-dolese-park",
      "search_query": "hunter's ridge oklahoma city by dolese park",
      "category": "Park",
      "h1_title": "Hunter's Ridge by Dolese Park, OKC",
      "h2_subtitle": "Enjoy the proximity to Dolese Park at Hunter's Ridge in Oklahoma City. Embrace active living in a vibrant community.",
      "page_copy": "Located in Oklahoma City, Hunter's Ridge Apts. offers residents a peaceful retreat with the added convenience of being close to Dolese Park. This location is perfect for those who enjoy an active outdoor lifestyle, providing easy access to the park's recreational facilities and open spaces.\n\nAt Hunter's Ridge Apts., you can choose from our well-designed one and two-bedroom floor plans, each crafted for comfort and style. Community amenities include a refreshing pool and a welcoming clubhouse, ideal for relaxation and socializing. Additionally, each unit boasts kitchen facilities and washer/dryer hookups. Enjoy living at the heart of Oklahoma City with the tranquility of nature nearby when you make Hunter's Ridge your home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a spa.",
        "public_id": "019cfb41-34a3-71ee-b967-565268701afb",
        "storage_key": "property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hunter's Ridge by Dolese Park, OKC",
      "seo_description": "Live near Dolese Park at Hunter's Ridge Apts in OKC. Enjoy modern living and outdoor adventures at our beautifully located community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5178"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-7ES8XPSHY9"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041152000"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/hunters-ridge/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WZ6VLX98"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165607/019d1bd8-48a1-70db-ae85-2bb7a3686044.pdf"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "5913163789"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-581-9768"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "64ac4ef6921c4946b802674e"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlFFTkJTN0Z1QWpQdTJ5ZTR3VTRtb1E9PSIsInZhbHVlIjoiNXB0M3JWYnpabWIyK0RTbU9ycFpmQT09IiwibWFjIjoiMTc4ZGE5ODA4MjBjZDAyMGQ3MWE0YmI5MTZiNDQ3ZmI1ZjJkOTliNmNiOGI4ODU3YjY1ZjU1NGVkM2M5YTM0MSJ9"
    }
  ],
  "custom_qb_id": "5178",
  "custom_ga4_id": "G-7ES8XPSHY9",
  "custom_repli_id": "10041152000",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/hunters-ridge/register/",
  "custom_google_gtm_id": "GTM-WZ6VLX98",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165607/019d1bd8-48a1-70db-ae85-2bb7a3686044.pdf",
  "custom_hubspot_company_id": "5913163789",
  "custom_ppc_tracking_phone_number": "844-581-9768",
  "custom_residentboost_apartment_id": "64ac4ef6921c4946b802674e",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlFFTkJTN0Z1QWpQdTJ5ZTR3VTRtb1E9PSIsInZhbHVlIjoiNXB0M3JWYnpabWIyK0RTbU9ycFpmQT09IiwibWFjIjoiMTc4ZGE5ODA4MjBjZDAyMGQ3MWE0YmI5MTZiNDQ3ZmI1ZjJkOTliNmNiOGI4ODU3YjY1ZjU1NGVkM2M5YTM0MSJ9"
};

export const generatedAt = '2026-08-27T21:37:56.270Z';
